export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  Long: { input: any; output: any };
  Upload: { input: any; output: any };
};

export type AcademicWeek = {
  __typename?: 'AcademicWeek';
  academicWeekNumber: Scalars['Int']['output'];
  calendarWeekNumber: Scalars['Int']['output'];
  endDate: Scalars['DateTime']['output'];
  isBlocked: Scalars['Boolean']['output'];
  period: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  weekNumber: Scalars['Int']['output'];
};

export type AcademicYear = {
  __typename?: 'AcademicYear';
  endDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isCurrentAcademicYearForAdmins: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  weeks: Array<AcademicWeek>;
};

export type AcceptPendingCoursePursuitInput = {
  coursePursuitId: Scalars['String']['input'];
  studentGroupId: Scalars['String']['input'];
};

export type AcceptPendingCoursePursuitPayload = {
  __typename?: 'AcceptPendingCoursePursuitPayload';
  mutationStatus: MutationStatus;
};

export type AcknowledgeRejectedCourseInput = {
  coursePursuitId: Scalars['String']['input'];
};

export type AcknowledgeRejectedCoursePayload = {
  __typename?: 'AcknowledgeRejectedCoursePayload';
  coursePursuitId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
};

export type AddApiKeyInput = {
  override: Scalars['Boolean']['input'];
  username: Scalars['String']['input'];
};

export type AddApiKeyPayload = {
  __typename?: 'AddApiKeyPayload';
  password: Scalars['String']['output'];
};

export type AddInfoRequirementMutationInput = {
  description: BilingualStringInput;
  ruleId: Scalars['String']['input'];
};

export type AddInfoRequirementMutationPayload = {
  __typename?: 'AddInfoRequirementMutationPayload';
  mutationStatus: MutationStatus;
  rule?: Maybe<Rule>;
};

export type AddMarblesCourseInput = {
  catalogNumber: Scalars['String']['input'];
  confirmedRedo: Scalars['Boolean']['input'];
  semesterId: Scalars['String']['input'];
};

export type AddMarblesCoursePayload = {
  __typename?: 'AddMarblesCoursePayload';
  course?: Maybe<MarblesCourseInfo>;
  coursePursuit?: Maybe<CoursePursuit>;
  coursePursuitId?: Maybe<Scalars['String']['output']>;
  duplicateInSemester: Scalars['Boolean']['output'];
  mutationStatus: MutationStatus;
};

export type AddRequiredCoursesMutationInput = {
  courses: RequiredCoursesInput;
  description: BilingualStringInput;
  ruleId: Scalars['String']['input'];
};

export type AddRequiredCoursesMutationPayload = {
  __typename?: 'AddRequiredCoursesMutationPayload';
  mutationStatus: MutationStatus;
  rule?: Maybe<Rule>;
};

export type AddRequiredPlanMutationInput = {
  plan: RequiredPlanInput;
  ruleId: Scalars['String']['input'];
};

export type AddRequiredPlanMutationPayload = {
  __typename?: 'AddRequiredPlanMutationPayload';
  mutationStatus: MutationStatus;
  rule?: Maybe<Rule>;
};

export type AddTopicMutationInput = {
  requirementNodeId?: InputMaybe<Scalars['String']['input']>;
  titleEN: Scalars['String']['input'];
  titleNL: Scalars['String']['input'];
  topicSetId: Scalars['String']['input'];
};

export type AddTopicMutationPayload = {
  __typename?: 'AddTopicMutationPayload';
  mutationStatus: MutationStatus;
  topic?: Maybe<Topic>;
};

export type AdministrativeProgramme = Programme & {
  __typename?: 'AdministrativeProgramme';
  code: Scalars['String']['output'];
  courseCodePrefix: Scalars['String']['output'];
  department: Department;
  departmentId: Scalars['String']['output'];
  description: BilingualString;
  id: Scalars['String']['output'];
  programmeType: ProgrammeType;
};

export type AdministrativelyDeregisterStudentForCourseInput = {
  coursePursuitId: Scalars['String']['input'];
  reason?: InputMaybe<StaffDeregistrationReason>;
};

export type AdministrativelyDeregisterStudentForCoursePayload = {
  __typename?: 'AdministrativelyDeregisterStudentForCoursePayload';
  courseOfferingId?: Maybe<Scalars['String']['output']>;
  coursePursuitId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
  reason?: Maybe<Scalars['String']['output']>;
  removed: Scalars['Boolean']['output'];
};

export type AdministrativelySelectCourseForRegistrationInput = {
  courseOfferingId: Scalars['String']['input'];
  skipRequirements: Scalars['Boolean']['input'];
  studentNumber: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['String']['input']>;
};

export type AdministrativelySelectCourseForRegistrationPayload = {
  __typename?: 'AdministrativelySelectCourseForRegistrationPayload';
  clusterPreference?: Maybe<CoursePursuitClusterPreference>;
  courseOfferingId?: Maybe<Scalars['String']['output']>;
  coursePursuitId?: Maybe<Scalars['String']['output']>;
  mutationStatus: MutationStatus;
  requirementsCheck?: Maybe<Requirements>;
  student?: Maybe<Student>;
  topicId?: Maybe<Scalars['String']['output']>;
};

export type AnnualTransitionCopyRequirementsInput = {
  dryRun: Scalars['Boolean']['input'];
  sourceYear: Scalars['Int']['input'];
  targetYear: Scalars['Int']['input'];
};

export type AnnualTransitionCopyRequirementsPayload = {
  __typename?: 'AnnualTransitionCopyRequirementsPayload';
  status: MutationStatus;
};

export type AnnualTransitionMutationInput = {
  copyConstrainedChoice: Scalars['Boolean']['input'];
  copyRules: Scalars['Boolean']['input'];
  copyTopics: Scalars['Boolean']['input'];
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dryRun: Scalars['Boolean']['input'];
  facultyId?: InputMaybe<Scalars['String']['input']>;
  offeringIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceYear: Scalars['Int']['input'];
  targetYear: Scalars['Int']['input'];
};

export type AnnualTransitionMutationPayload = {
  __typename?: 'AnnualTransitionMutationPayload';
  status: MutationStatus;
};

export enum ApplicationModule {
  Facet = 'FACET',
  Goblet = 'GOBLET',
  GobletLegacy = 'GOBLET_LEGACY',
  Prism = 'PRISM',
  Quartz = 'QUARTZ',
}

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION',
}

export type AuthorisationRights = {
  __typename?: 'AuthorisationRights';
  departments: Array<Department>;
  userRoles: Array<UserRole>;
};

export type AuthoriseUserInput = {
  departmentId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AuthoriseUserPayload = {
  __typename?: 'AuthoriseUserPayload';
  mutationStatus: MutationStatus;
  roleAssignment?: Maybe<RoleAssignment>;
  username: Scalars['String']['output'];
};

export enum BeforeOrAfter {
  After = 'AFTER',
  Before = 'BEFORE',
}

export type BenchmarkResults = {
  __typename?: 'BenchmarkResults';
  offeringId?: Maybe<Scalars['String']['output']>;
  students: Scalars['Int']['output'];
  time: Scalars['Long']['output'];
};

export type BilingualString = {
  __typename?: 'BilingualString';
  EN: Scalars['String']['output'];
  NL: Scalars['String']['output'];
};

export type BilingualStringInput = {
  EN: Scalars['String']['input'];
  NL: Scalars['String']['input'];
};

export type BulkAcceptRejectCoursesInput = {
  accept: Array<BulkAcceptRejectCoursesInputAcceptRowInput>;
  reject: Array<BulkAcceptRejectCoursesInputRejectRowInput>;
};

export type BulkAcceptRejectCoursesInputAcceptRowInput = {
  courseOfferingId: Scalars['String']['input'];
  studentGroupId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};

export type BulkAcceptRejectCoursesInputRejectRowInput = {
  courseOfferingId: Scalars['String']['input'];
  reason: RejectionReason;
  studentId: Scalars['String']['input'];
};

export type BulkAcceptRejectCoursesPayload = {
  __typename?: 'BulkAcceptRejectCoursesPayload';
  failedRows: Array<BulkAcceptRejectCoursesPayloadRow>;
  numFailed: Scalars['Int']['output'];
  numProcessed: Scalars['Int']['output'];
  numSucceeded: Scalars['Int']['output'];
};

export type BulkAcceptRejectCoursesPayloadRow = {
  __typename?: 'BulkAcceptRejectCoursesPayloadRow';
  courseOfferingId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  status: MutationStatus;
  studentId: Scalars['String']['output'];
};

export type BulkDeregisterMarkedPursuitsPayload = {
  __typename?: 'BulkDeregisterMarkedPursuitsPayload';
  cancelledDeregistrationRows: Array<BulkDeregisterMarkedPursuitsPayloadRow>;
  deregisteredRows: Array<BulkDeregisterMarkedPursuitsPayloadRow>;
};

export type BulkDeregisterMarkedPursuitsPayloadRow = {
  __typename?: 'BulkDeregisterMarkedPursuitsPayloadRow';
  creationDate: Scalars['DateTime']['output'];
  pursuitId: Scalars['String']['output'];
  studentId: Scalars['String']['output'];
};

export type BulkRejectInactiveStudentsPayload = {
  __typename?: 'BulkRejectInactiveStudentsPayload';
  rejectedPursuits: Array<BulkRejectInactiveStudentsPayloadRow>;
};

export type BulkRejectInactiveStudentsPayloadRow = {
  __typename?: 'BulkRejectInactiveStudentsPayloadRow';
  pursuitId: Scalars['String']['output'];
  status: MutationStatus;
  studentId: Scalars['String']['output'];
};

export type CancelGroupSwapRequestInput = {
  coursePursuitId: Scalars['String']['input'];
  groupSwapRequestId: Scalars['String']['input'];
};

export type CancelGroupSwapRequestPayload = {
  __typename?: 'CancelGroupSwapRequestPayload';
  coursePursuitId: Scalars['String']['output'];
  groupSwapRequestId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
};

export type Career = {
  __typename?: 'Career';
  code: Scalars['String']['output'];
  description: BilingualString;
  id: Scalars['String']['output'];
};

export type CertificateProgramme = Programme & {
  __typename?: 'CertificateProgramme';
  certificateProgrammeType: CertificateProgrammeType;
  code: Scalars['String']['output'];
  courseCodePrefix: Scalars['String']['output'];
  credits: Scalars['Float']['output'];
  department: Department;
  departmentId: Scalars['String']['output'];
  description: BilingualString;
  id: Scalars['String']['output'];
  programmeType: ProgrammeType;
};

export enum CertificateProgrammeType {
  ContractTeaching = 'CONTRACT_TEACHING',
  Exchange = 'EXCHANGE',
  Minor = 'MINOR',
  PreMaster = 'PRE_MASTER',
  SummerSchool = 'SUMMER_SCHOOL',
}

export type ChangeCourseOwnerInput = {
  academicYear: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  programmeId: Scalars['String']['input'];
};

export type ChangeCourseOwnerPayload = {
  __typename?: 'ChangeCourseOwnerPayload';
  course?: Maybe<Course>;
  mutationStatus: MutationStatus;
};

export type ClearTimetablePreferencesInput = {
  dryRun: Scalars['Boolean']['input'];
};

export type ClearTimetablePreferencesPayload = {
  __typename?: 'ClearTimetablePreferencesPayload';
  rowCount: Scalars['Int']['output'];
  rows: Array<ClearTimetablePreferencesPayloadRow>;
};

export type ClearTimetablePreferencesPayloadRow = {
  __typename?: 'ClearTimetablePreferencesPayloadRow';
  status: MutationStatus;
  studentId: Scalars['String']['output'];
};

export type ClearTokenCacheInput = {
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ClearTokenCachePayload = {
  __typename?: 'ClearTokenCachePayload';
  cleared: Scalars['Boolean']['output'];
};

export type ConstrainedChoiceCluster = {
  __typename?: 'ConstrainedChoiceCluster';
  academicYear: MarblesAcademicYear;
  department: MarblesDepartment;
  departmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  offerings: Array<MarblesCourseOffering>;
  registrationLimit: Scalars['Int']['output'];
  title: BilingualString;
};

export type ConstrainedChoiceClusterSetting = {
  __typename?: 'ConstrainedChoiceClusterSetting';
  academicYear: MarblesAcademicYear;
  constrainedChoiceCluster?: Maybe<ConstrainedChoiceCluster>;
  coursePursuitIds: Array<Scalars['String']['output']>;
  credits: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  registrationLimit: Scalars['Int']['output'];
};

export type CopyRequirementMutationInput = {
  departmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  requirementId: Scalars['String']['input'];
};

export type CopyRequirementMutationPayload = {
  __typename?: 'CopyRequirementMutationPayload';
  mutationStatus: MutationStatus;
  requirement?: Maybe<Requirement>;
};

export type CopyRuleMutationInput = {
  departmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
};

export type CopyRuleMutationPayload = {
  __typename?: 'CopyRuleMutationPayload';
  mutationStatus: MutationStatus;
  rule?: Maybe<Rule>;
};

export type Course = {
  __typename?: 'Course';
  allowedUserActions: Array<UserAction>;
  attributes: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  credits: Scalars['Float']['output'];
  department: Department;
  departmentId: Scalars['String']['output'];
  descriptions?: Maybe<CourseCatalogDescriptions>;
  descriptionsValidationStatus: ValidationDetails;
  gradingScheme?: Maybe<GradingScheme>;
  id: Scalars['String']['output'];
  isNew: Scalars['Boolean']['output'];
  level: CourseLevel;
  name: BilingualString;
  nextOfferingNumber: Scalars['Int']['output'];
  offerings: Array<CourseOffering>;
  programme: Programme;
  programmeId: Scalars['String']['output'];
  settings: CourseSettings;
  type: CourseType;
  validationStatus: ValidationDetails;
};

export type CourseDescriptionsArgs = {
  academicYear: Scalars['Int']['input'];
};

export type CourseDescriptionsValidationStatusArgs = {
  academicYear: Scalars['Int']['input'];
};

export type CourseNextOfferingNumberArgs = {
  academicYear: Scalars['Int']['input'];
};

export type CourseOfferingsArgs = {
  academicYear: Scalars['Int']['input'];
};

export type CourseSettingsArgs = {
  academicYear: Scalars['Int']['input'];
};

export type CourseValidationStatusArgs = {
  academicYear: Scalars['Int']['input'];
};

export type CourseAttributesPayload = {
  __typename?: 'CourseAttributesPayload';
  attributes: Array<Scalars['String']['output']>;
  courseType: CourseType;
};

export type CourseCatalogDescriptions = {
  __typename?: 'CourseCatalogDescriptions';
  assessment: Scalars['String']['output'];
  contents: Scalars['String']['output'];
  entryRequirements: Scalars['String']['output'];
  objectives: Array<Scalars['String']['output']>;
  objectivesIntroduction: Scalars['String']['output'];
  participants: Scalars['String']['output'];
  recommendedPriorKnowledge: Scalars['String']['output'];
  registration: Scalars['String']['output'];
  remarks: Scalars['String']['output'];
  requiredPriorKnowledge: Scalars['String']['output'];
  studyMaterials: Scalars['String']['output'];
  teachingMethod: Scalars['String']['output'];
};

export type CourseCatalogDescriptionsInput = {
  assessment: Scalars['String']['input'];
  contents: Scalars['String']['input'];
  entryRequirements: Scalars['String']['input'];
  objectives: Array<Scalars['String']['input']>;
  objectivesIntroduction: Scalars['String']['input'];
  participants: Scalars['String']['input'];
  recommendedPriorKnowledge: Scalars['String']['input'];
  registration: Scalars['String']['input'];
  remarks: Scalars['String']['input'];
  requiredPriorKnowledge: Scalars['String']['input'];
  studyMaterials: Scalars['String']['input'];
  teachingMethod: Scalars['String']['input'];
};

export enum CourseLevel {
  BachelorBase = 'BACHELOR_BASE',
  BachelorExpert = 'BACHELOR_EXPERT',
  BachelorIntro = 'BACHELOR_INTRO',
  DualMaster = 'DUAL_MASTER',
  Master = 'MASTER',
  None = 'NONE',
  PhD = 'PH_D',
  ResearchMaster = 'RESEARCH_MASTER',
}

export type CourseOffering = {
  __typename?: 'CourseOffering';
  academicYear: Scalars['Int']['output'];
  allowedUserActions: Array<UserAction>;
  code: Scalars['String']['output'];
  coordinator?: Maybe<User>;
  course: Course;
  courseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  instructionLanguage: Language;
  lecturers: Array<CourseOfferingLecturer>;
  offeringNumber: Scalars['Int']['output'];
  periods: Array<Scalars['Int']['output']>;
  studentGroups: Array<StudentGroup>;
  timetableConstraints?: Maybe<TimetableConstraints>;
};

export type CourseOfferingCapacity = {
  __typename?: 'CourseOfferingCapacity';
  available: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CourseOfferingLecturer = {
  __typename?: 'CourseOfferingLecturer';
  courseOfferingId: Scalars['String']['output'];
  displayInCourseCatalog: Scalars['Boolean']['output'];
  lecturer: User;
  studentGroups: Array<StudentGroup>;
};

export type CourseOfferingPendingGroupSwap = {
  __typename?: 'CourseOfferingPendingGroupSwap';
  courseId: Scalars['String']['output'];
  courseOfferingId: Scalars['String']['output'];
  info?: Maybe<MarblesCourseInfo>;
  lastRequestDate: Scalars['DateTime']['output'];
  requestCount: Scalars['Int']['output'];
  requestExpirationDate: Scalars['DateTime']['output'];
  requestPossible: Scalars['Boolean']['output'];
};

export type CourseOfferingRequirementCapacity = {
  __typename?: 'CourseOfferingRequirementCapacity';
  allocationRound: Scalars['Int']['output'];
  description?: Maybe<BilingualString>;
  includeInRetry: Scalars['Boolean']['output'];
  pending: Scalars['Int']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  priorityLimit?: Maybe<Scalars['Int']['output']>;
  registered: Scalars['Int']['output'];
  ruleId?: Maybe<Scalars['String']['output']>;
};

export type CourseOfferingTopicCapacity = {
  __typename?: 'CourseOfferingTopicCapacity';
  availableCapacity: Scalars['Int']['output'];
  groupCount: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  registered: Scalars['Int']['output'];
  topic: Topic;
};

export type CoursePursuit = {
  __typename?: 'CoursePursuit';
  clusterPreference?: Maybe<CoursePursuitClusterPreference>;
  course: StudentCourse;
  courseInfo: MarblesCourseInfo;
  coursePursuitStatus: CoursePursuitStatus;
  id: Scalars['String']['output'];
  isGroupSwapPossible: Scalars['Boolean']['output'];
  pendingGroupSwapRequestId?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['DateTime']['output']>;
  rejectionReason?: Maybe<RejectionReason>;
  requirementsCheck?: Maybe<Requirements>;
  selectedOffering?: Maybe<MarblesCourseOffering>;
  student: Student;
  studentGroup?: Maybe<StudentGroup>;
  topicId?: Maybe<Scalars['String']['output']>;
};

export enum CoursePursuitAction {
  Accepted = 'ACCEPTED',
  AcceptedAdministratively = 'ACCEPTED_ADMINISTRATIVELY',
  Added = 'ADDED',
  Deregistered = 'DEREGISTERED',
  Deselected = 'DESELECTED',
  RegisteredAdministratively = 'REGISTERED_ADMINISTRATIVELY',
  RegisteredDirectly = 'REGISTERED_DIRECTLY',
  Rejected = 'REJECTED',
  RejectedCourseAcknowledged = 'REJECTED_COURSE_ACKNOWLEDGED',
  Removed = 'REMOVED',
  Selected = 'SELECTED',
  SwitchedGroup = 'SWITCHED_GROUP',
  UpdatedTopic = 'UPDATED_TOPIC',
}

export type CoursePursuitAudit = {
  __typename?: 'CoursePursuitAudit';
  academicYear?: Maybe<MarblesAcademicYear>;
  action: CoursePursuitAction;
  catalogNumber?: Maybe<Scalars['String']['output']>;
  course?: Maybe<BilingualString>;
  courseOfferingId?: Maybe<Scalars['String']['output']>;
  deregistrationReason?: Maybe<DeregistrationReason>;
  new?: Maybe<BilingualString>;
  old?: Maybe<BilingualString>;
  pursuitId: Scalars['String']['output'];
  registrationRound?: Maybe<RegistrationRound>;
  studentId: Scalars['String']['output'];
  timeStamp: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type CoursePursuitClusterPreference = {
  __typename?: 'CoursePursuitClusterPreference';
  index: Scalars['Int']['output'];
  pursuitCount: Scalars['Int']['output'];
  registrationLimit: Scalars['Int']['output'];
};

export enum CoursePursuitStatus {
  Added = 'ADDED',
  Deregistered = 'DEREGISTERED',
  Pending = 'PENDING',
  Registered = 'REGISTERED',
  Rejected = 'REJECTED',
}

export enum CourseRegistrationSource {
  Glass = 'GLASS',
  None = 'NONE',
  Sis = 'SIS',
}

export type CourseSettings = {
  __typename?: 'CourseSettings';
  ansEnabled: Scalars['Boolean']['output'];
  courseCatalogEnabled: Scalars['Boolean']['output'];
  courseCatalogIsOpenUvACourse: Scalars['Boolean']['output'];
  courseRegistrationEnabled: Scalars['Boolean']['output'];
  courseRegistrationSource: CourseRegistrationSource;
  craAllowIncompleteGradeLists: Scalars['Boolean']['output'];
  craEnabled: Scalars['Boolean']['output'];
  lmsCopyContentsFromPreviousYear: Scalars['Boolean']['output'];
  lmsEnablePrivacySection: Scalars['Boolean']['output'];
  lmsEnabled: Scalars['Boolean']['output'];
  sisEnabled: Scalars['Boolean']['output'];
  sisOfferingIdsAvailableForExchangeStudents: Array<Scalars['String']['output']>;
  timetableConstraintsEnabled: Scalars['Boolean']['output'];
  timetableEnabled: Scalars['Boolean']['output'];
  timetableLocation: TimetableLocation;
};

export enum CourseType {
  Individual = 'INDIVIDUAL',
  Internship = 'INTERNSHIP',
  MatchingSelection = 'MATCHING_SELECTION',
  NonEducation = 'NON_EDUCATION',
  Regular = 'REGULAR',
  Thesis = 'THESIS',
}

export type CreateConstrainedChoiceClusterMutationInput = {
  academicYear: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
  titleEN: Scalars['String']['input'];
  titleNL: Scalars['String']['input'];
};

export type CreateConstrainedChoiceClusterMutationPayload = {
  __typename?: 'CreateConstrainedChoiceClusterMutationPayload';
  academicYear: Scalars['Int']['output'];
  constrainedChoiceCluster?: Maybe<ConstrainedChoiceCluster>;
  mutationStatus: MutationStatus;
};

export type CreateCourseInput = {
  academicYear: Scalars['Int']['input'];
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  code: Scalars['String']['input'];
  credits: Scalars['Float']['input'];
  gradingScheme?: InputMaybe<GradingScheme>;
  level: CourseLevel;
  nameEN: Scalars['String']['input'];
  nameNL: Scalars['String']['input'];
  offerings: Array<CreateCourseInputOfferingInput>;
  programmeId: Scalars['String']['input'];
  type: CourseType;
};

export type CreateCourseInputOfferingInput = {
  coordinator?: InputMaybe<Scalars['String']['input']>;
  instructionLanguage: Language;
  periods: Array<Scalars['Int']['input']>;
};

export type CreateCoursePayload = {
  __typename?: 'CreateCoursePayload';
  course?: Maybe<Course>;
  mutationStatus: MutationStatus;
};

export type CreateGroupSwapRequestErrorPayload = CreateGroupSwapRequestPayload & {
  __typename?: 'CreateGroupSwapRequestErrorPayload';
  coursePursuitId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
  reason: BilingualString;
};

export type CreateGroupSwapRequestInput = {
  coursePursuitId: Scalars['String']['input'];
  requestedStudentGroupIds: Array<Scalars['String']['input']>;
};

export type CreateGroupSwapRequestPayload = {
  coursePursuitId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
};

export type CreateGroupSwapRequestSuccessPayload = CreateGroupSwapRequestPayload & {
  __typename?: 'CreateGroupSwapRequestSuccessPayload';
  coursePursuitId: Scalars['String']['output'];
  expirationDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  mutationStatus: MutationStatus;
  requestedStudentGroupIds: Array<Scalars['String']['output']>;
};

export type CreateRequirementMutationInput = {
  academicYear: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
};

export type CreateRequirementMutationPayload = {
  __typename?: 'CreateRequirementMutationPayload';
  academicYear: Scalars['Int']['output'];
  mutationStatus: MutationStatus;
  requirement?: Maybe<Requirement>;
};

export type CreateRuleRequiredCareerMutationInput = {
  academicYear: Scalars['Int']['input'];
  careerIds: Array<Scalars['String']['input']>;
  departmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateRuleRequiredCareerMutationPayload = {
  __typename?: 'CreateRuleRequiredCareerMutationPayload';
  academicYear: Scalars['Int']['output'];
  mutationStatus: MutationStatus;
  rule?: Maybe<Rule>;
};

export type CreateRuleRequiredPlanMutationInput = {
  academicYear: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  plan: RequiredPlanInput;
};

export type CreateRuleRequiredPlanMutationPayload = {
  __typename?: 'CreateRuleRequiredPlanMutationPayload';
  academicYear: Scalars['Int']['output'];
  mutationStatus: MutationStatus;
  rule?: Maybe<Rule>;
};

export type CreateRuleRequiredStudentSetMutationInput = {
  academicYear: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  studentSetId: Scalars['String']['input'];
};

export type CreateRuleRequiredStudentSetMutationPayload = {
  __typename?: 'CreateRuleRequiredStudentSetMutationPayload';
  academicYear: Scalars['Int']['output'];
  mutationStatus: MutationStatus;
  rule?: Maybe<Rule>;
};

export type CreateTopicSetMutationInput = {
  academicYear: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  titleEN: Scalars['String']['input'];
  titleNL: Scalars['String']['input'];
};

export type CreateTopicSetMutationPayload = {
  __typename?: 'CreateTopicSetMutationPayload';
  academicYear: Scalars['Int']['output'];
  mutationStatus: MutationStatus;
  topicSet?: Maybe<TopicSet>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export enum DegreeLevel {
  Bachelor = 'BACHELOR',
  Master = 'MASTER',
  PostInitialMaster = 'POST_INITIAL_MASTER',
}

export type DegreeProgramme = Programme & {
  __typename?: 'DegreeProgramme';
  code: Scalars['String']['output'];
  courseCodePrefix: Scalars['String']['output'];
  credits: Scalars['Float']['output'];
  degreeLevel: DegreeLevel;
  department: Department;
  departmentId: Scalars['String']['output'];
  description: BilingualString;
  id: Scalars['String']['output'];
  programmeType: ProgrammeType;
};

export type Department = {
  __typename?: 'Department';
  allowedUserActions: Array<UserAction>;
  code: Scalars['String']['output'];
  courseAttributes: Array<CourseAttributesPayload>;
  id: Scalars['String']['output'];
  name: BilingualString;
  parentId?: Maybe<Scalars['String']['output']>;
};

export type DeregisterCourseInput = {
  coursePursuitId: Scalars['String']['input'];
};

export type DeregisterCoursePayload = {
  __typename?: 'DeregisterCoursePayload';
  coursePursuitId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
  removed: Scalars['Boolean']['output'];
};

export enum DeregistrationReason {
  Administrative = 'ADMINISTRATIVE',
  CourseCancelled = 'COURSE_CANCELLED',
  EngineDetectedInactiveEnrolment = 'ENGINE_DETECTED_INACTIVE_ENROLMENT',
  StudentExceedsCreditLimit = 'STUDENT_EXCEEDS_CREDIT_LIMIT',
  StudentFailedRequirements = 'STUDENT_FAILED_REQUIREMENTS',
  StudentQuitsProgramme = 'STUDENT_QUITS_PROGRAMME',
  StudentRequestedDeregistration = 'STUDENT_REQUESTED_DEREGISTRATION',
  StudentSelfDeregistration = 'STUDENT_SELF_DEREGISTRATION',
}

export type DeselectCourseForRegistrationInput = {
  coursePursuitId: Scalars['String']['input'];
};

export type DeselectCourseForRegistrationPayload = {
  __typename?: 'DeselectCourseForRegistrationPayload';
  constrainedChoiceClusterSetting?: Maybe<ConstrainedChoiceClusterSetting>;
  coursePursuitId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
};

export type Diagnostic = {
  __typename?: 'Diagnostic';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DirectRegisterForCourseInput = {
  courseOfferingId: Scalars['String']['input'];
  coursePursuitId: Scalars['String']['input'];
};

export type DirectRegisterForCoursePayload = {
  __typename?: 'DirectRegisterForCoursePayload';
  blockReason?: Maybe<RequirementBlockedReason>;
  courseOfferingId?: Maybe<Scalars['String']['output']>;
  coursePursuitId?: Maybe<Scalars['String']['output']>;
  mutationStatus: MutationStatus;
  studentGroup?: Maybe<StudentGroup>;
};

export type DirectRegistrationSettings = {
  __typename?: 'DirectRegistrationSettings';
  directRegistrationType: DirectRegistrationType;
  registrationEndDate: Scalars['DateTime']['output'];
  registrationStartDate: Scalars['DateTime']['output'];
};

export enum DirectRegistrationType {
  DirectRegistrationOnly = 'DIRECT_REGISTRATION_ONLY',
  Disabled = 'DISABLED',
  Tgow = 'TGOW',
}

export type DownloadLink = {
  __typename?: 'DownloadLink';
  url: Scalars['String']['output'];
};

export type DummyAlgorithmInput = {
  rejectCatalogNumbers: Array<Scalars['String']['input']>;
  studentId: Scalars['String']['input'];
};

export type DummyAlgorithmPayload = {
  __typename?: 'DummyAlgorithmPayload';
  mutationStatus: MutationStatus;
};

export type EnableDirectRegistrationInput = {
  studentGroupId: Scalars['String']['input'];
};

export type EnableDirectRegistrationPayload = {
  __typename?: 'EnableDirectRegistrationPayload';
  mutationStatus: MutationStatus;
};

export type Enrolment = {
  __typename?: 'Enrolment';
  career: Career;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  plan: Plan;
  startDate: Scalars['DateTime']['output'];
  subplans: Array<Subplan>;
};

export type ExecuteGroupSwapInput = {
  courseOfferingId?: InputMaybe<Scalars['String']['input']>;
  dryRunExecute: Scalars['Boolean']['input'];
  dryRunExpire: Scalars['Boolean']['input'];
  forceExecuteAllRequests: Scalars['Boolean']['input'];
  notifyStudents: Scalars['Boolean']['input'];
};

export type ExecuteGroupSwapOutput = {
  __typename?: 'ExecuteGroupSwapOutput';
  completedRequests: Array<GroupSwapRequest>;
  expiredRequests: Array<GroupSwapRequest>;
  mutationStatus: MutationStatus;
};

export type ForceRemoveCourseInput = {
  coursePursuitId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};

export type ForceRemoveCoursePayload = {
  __typename?: 'ForceRemoveCoursePayload';
  mutationStatus: MutationStatus;
};

export type ForceUpdateConstrainedChoiceSettingInput = {
  credits: Scalars['Float']['input'];
  pursuitIds: Array<Scalars['String']['input']>;
  registrationLimit: Scalars['Int']['input'];
  settingsId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};

export type ForceUpdateConstrainedChoiceSettingPayload = {
  __typename?: 'ForceUpdateConstrainedChoiceSettingPayload';
  mutationStatus: MutationStatus;
};

export enum GradingScheme {
  Af = 'AF',
  An = 'AN',
  Dc1 = 'DC1',
  Dk1 = 'DK1',
  Hlf = 'HLF',
  Pt = 'PT',
  Tsc = 'TSC',
  Vo = 'VO',
}

export type GroupRequirementNode = {
  description: BilingualString;
  id: Scalars['String']['output'];
  type: RequirementNodeType;
};

export type GroupSwapRequest = {
  __typename?: 'GroupSwapRequest';
  courseOfferingId: Scalars['String']['output'];
  coursePursuitId: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  expirationDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /** admin */
  newStudentGroup?: Maybe<StudentGroup>;
  newStudentGroupId?: Maybe<Scalars['String']['output']>;
  processedBy?: Maybe<Scalars['String']['output']>;
  requestedStudentGroupIds: Array<Scalars['String']['output']>;
  status: GroupSwapStatus;
  /** admin */
  student: Student;
  /** admin */
  studentGroup?: Maybe<StudentGroup>;
  studentGroupId: Scalars['String']['output'];
  studentId: Scalars['String']['output'];
  updateDate: Scalars['DateTime']['output'];
};

export enum GroupSwapStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
}

export type InfoRequirement = RequirementNode & {
  __typename?: 'InfoRequirement';
  description: BilingualString;
  id: Scalars['String']['output'];
  type: RequirementNodeType;
};

export enum Language {
  Ara = 'ARA',
  Cat = 'CAT',
  Ces = 'CES',
  Dan = 'DAN',
  Deu = 'DEU',
  Dse = 'DSE',
  Ell = 'ELL',
  Eng = 'ENG',
  Fra = 'FRA',
  Fry = 'FRY',
  Grc = 'GRC',
  Hbs = 'HBS',
  Heb = 'HEB',
  Ita = 'ITA',
  Nld = 'NLD',
  Nor = 'NOR',
  Pol = 'POL',
  Por = 'POR',
  Ron = 'RON',
  Rus = 'RUS',
  Spa = 'SPA',
  Swe = 'SWE',
}

export type LiftSuspensionInput = {
  username: Scalars['String']['input'];
};

export type LiftSuspensionPayload = {
  __typename?: 'LiftSuspensionPayload';
  mutationStatus: MutationStatus;
};

export type LockStudentGroupInput = {
  studentGroupId: Scalars['String']['input'];
};

export type LockStudentGroupPayload = {
  __typename?: 'LockStudentGroupPayload';
  mutationStatus: MutationStatus;
  studentGroupId: Scalars['String']['output'];
};

export type MaintenanceMessage = {
  __typename?: 'MaintenanceMessage';
  message: Scalars['String']['output'];
  severity: MaintenanceMessageSeverity;
};

export enum MaintenanceMessageSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING',
}

export type MarblesAcademicYear = {
  __typename?: 'MarblesAcademicYear';
  endDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isCurrentAcademicYearForAdmins: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type MarblesAuthorisationRights = {
  __typename?: 'MarblesAuthorisationRights';
  departments: Array<MarblesDepartment>;
  userRoles: Array<UserRole>;
};

export type MarblesAuthoriseUserMutationInput = {
  departmentId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MarblesAuthoriseUserMutationPayload = {
  __typename?: 'MarblesAuthoriseUserMutationPayload';
  mutationStatus: MutationStatus;
  roleAssignment?: Maybe<MarblesRoleAssignment>;
  username: Scalars['String']['output'];
};

export type MarblesCourseInfo = {
  __typename?: 'MarblesCourseInfo';
  catalogNumber: Scalars['String']['output'];
  ec: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  relevantOfferings: Array<MarblesCourseOffering>;
  title: BilingualString;
};

export type MarblesCourseInfoRelevantOfferingsArgs = {
  semesterId: Scalars['String']['input'];
};

export type MarblesCourseOffering = {
  __typename?: 'MarblesCourseOffering';
  academicYear: MarblesAcademicYear;
  availableForRegistration: Scalars['Boolean']['output'];
  capacity?: Maybe<CourseOfferingCapacity>;
  constrainedChoiceCluster?: Maybe<ConstrainedChoiceCluster>;
  constrainedChoiceClusterId?: Maybe<Scalars['String']['output']>;
  credits: Scalars['Float']['output'];
  /** admin */
  department: MarblesDepartment;
  /** admin */
  departmentId: Scalars['String']['output'];
  directRegistrationEnabled: Scalars['Boolean']['output'];
  directRegistrationSettings: DirectRegistrationSettings;
  finalDeregistrationDate?: Maybe<Scalars['DateTime']['output']>;
  /** admin */
  groupSwapEnabled: Scalars['Boolean']['output'];
  groupSwapExpirationDate: Scalars['DateTime']['output'];
  hasCreditLimitException: Scalars['Boolean']['output'];
  hasRequirements: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  info?: Maybe<MarblesCourseInfo>;
  /** admin */
  numberOfPendingStudents: Scalars['Int']['output'];
  /** admin */
  numberOfRegisteredStudents: Scalars['Int']['output'];
  periods: Array<Period>;
  registrationPeriod: Period;
  relevantTopicIds: Array<Scalars['String']['output']>;
  /** admin */
  requirementNodeId?: Maybe<Scalars['String']['output']>;
  semesters: Array<Semester>;
  status: MarblesCourseOfferingStatus;
  /** admin */
  studentGroups: Array<StudentGroup>;
  timeTableUrl?: Maybe<Scalars['String']['output']>;
  topicCapacities: Array<TopicCapacity>;
  topicSet?: Maybe<TopicSet>;
};

export type MarblesCourseOfferingAvailableForRegistrationArgs = {
  semesterId: Scalars['String']['input'];
};

export type MarblesCourseOfferingCreditsArgs = {
  semesterId: Scalars['String']['input'];
};

export enum MarblesCourseOfferingStatus {
  ActiveClosed = 'ACTIVE_CLOSED',
  ActiveOpen = 'ACTIVE_OPEN',
  DirectRegistrationOnly = 'DIRECT_REGISTRATION_ONLY',
  Inactive = 'INACTIVE',
}

export type MarblesCourseSearchResult = {
  __typename?: 'MarblesCourseSearchResult';
  courses: Array<MarblesCourseInfo>;
  totalCount: Scalars['Int']['output'];
};

export type MarblesDepartment = {
  __typename?: 'MarblesDepartment';
  allowedUserActions: Array<UserAction>;
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: BilingualString;
  parentId?: Maybe<Scalars['String']['output']>;
};

export type MarblesLiftSuspensionMutationPayload = {
  __typename?: 'MarblesLiftSuspensionMutationPayload';
  mutationStatus: MutationStatus;
};

export type MarblesRevokeAuthorisationMutationInput = {
  id: Scalars['Int']['input'];
};

export type MarblesRevokeAuthorisationMutationPayload = {
  __typename?: 'MarblesRevokeAuthorisationMutationPayload';
  mutationStatus: MutationStatus;
};

export type MarblesRoleAssignment = {
  __typename?: 'MarblesRoleAssignment';
  createdBy: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  department: MarblesDepartment;
  id: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  userActions: Array<UserAction>;
  userRole: UserRole;
};

export type MarblesUser = {
  __typename?: 'MarblesUser';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  isAdminPanelUser: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleAssignments: Array<MarblesRoleAssignment>;
  status: UserStatus;
  student?: Maybe<Student>;
  studentId?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type MarkPursuitsForDeregistrationPayload = {
  __typename?: 'MarkPursuitsForDeregistrationPayload';
  rows: Array<MarkPursuitsForDeregistrationPayloadRow>;
};

export type MarkPursuitsForDeregistrationPayloadRow = {
  __typename?: 'MarkPursuitsForDeregistrationPayloadRow';
  pursuitId: Scalars['String']['output'];
  studentId: Scalars['String']['output'];
};

export type MigrationIssue = {
  __typename?: 'MigrationIssue';
  missingClusterId?: Maybe<Scalars['String']['output']>;
  missingRequirementId?: Maybe<Scalars['String']['output']>;
  missingTopicSetId?: Maybe<Scalars['String']['output']>;
  offeringId: Scalars['String']['output'];
};

export enum MissingColumn {
  CatalogNumber = 'CATALOG_NUMBER',
  ClassNumber = 'CLASS_NUMBER',
  CreditLimitException = 'CREDIT_LIMIT_EXCEPTION',
  GroupCapacity = 'GROUP_CAPACITY',
  GroupCode = 'GROUP_CODE',
  Period = 'PERIOD',
  StudentId = 'STUDENT_ID',
  Topic = 'TOPIC',
}

export type Mutation = {
  __typename?: 'Mutation';
  /** algorithm/admin */
  acceptPendingCoursePursuit: AcceptPendingCoursePursuitPayload;
  /** student */
  acknowledgeRejectedCourse: AcknowledgeRejectedCoursePayload;
  /** admin */
  addApiKey: AddApiKeyPayload;
  /** admin */
  addInfoRequirement: AddInfoRequirementMutationPayload;
  /** student */
  addMarblesCourse: AddMarblesCoursePayload;
  /** admin */
  addRequiredCourses: AddRequiredCoursesMutationPayload;
  /** admin */
  addRequiredPlan: AddRequiredPlanMutationPayload;
  /** admin */
  addTopic: AddTopicMutationPayload;
  /** admin */
  administrativelySelectCourseForRegistration: AdministrativelySelectCourseForRegistrationPayload;
  /** admin */
  annualTransitionCopyRequirementMutation: AnnualTransitionCopyRequirementsPayload;
  /** admin */
  annualTransitionMutation: AnnualTransitionMutationPayload;
  /** admin */
  authoriseUser: AuthoriseUserPayload;
  /** admin */
  bulkAcceptRejectCourses: BulkAcceptRejectCoursesPayload;
  /** admin */
  bulkDeregisterMarkedPursuits: BulkDeregisterMarkedPursuitsPayload;
  /** admin */
  bulkRejectInactiveStudents: BulkRejectInactiveStudentsPayload;
  /** student */
  cancelGroupSwapRequest: CancelGroupSwapRequestPayload;
  changeCourseOwner: ChangeCourseOwnerPayload;
  clearCache: Scalars['Boolean']['output'];
  /** admin */
  clearTimetablePreferences: ClearTimetablePreferencesPayload;
  /** admin */
  clearTokenCache: ClearTokenCachePayload;
  /** admin */
  copyRequirement: CopyRequirementMutationPayload;
  /** admin */
  copyRule: CopyRuleMutationPayload;
  /** admin */
  createConstrainedChoiceCluster: CreateConstrainedChoiceClusterMutationPayload;
  createCourse: CreateCoursePayload;
  /** student */
  createGroupSwapRequest: CreateGroupSwapRequestPayload;
  /** admin */
  createRequirement: CreateRequirementMutationPayload;
  /** admin */
  createRuleRequiredCareer: CreateRuleRequiredCareerMutationPayload;
  /** admin */
  createRuleRequiredPlan: CreateRuleRequiredPlanMutationPayload;
  /** admin */
  createRuleRequiredStudentSet: CreateRuleRequiredStudentSetMutationPayload;
  /** admin */
  createTopicSet: CreateTopicSetMutationPayload;
  /** student */
  deregisterCourse: DeregisterCoursePayload;
  /** admin */
  deregisterStudentForCourse: AdministrativelyDeregisterStudentForCoursePayload;
  /** student */
  deselectCourseForRegistration: DeselectCourseForRegistrationPayload;
  /** student */
  directRegisterForCourse: DirectRegisterForCoursePayload;
  /** algorithm/admin */
  dummyAlgorithm: DummyAlgorithmPayload;
  /** admin */
  enableDirectRegistration: EnableDirectRegistrationPayload;
  /** admin */
  executeGroupSwap: ExecuteGroupSwapOutput;
  /** admin */
  fixCounters: Scalars['Boolean']['output'];
  /** admin */
  forceRemoveCourse: ForceRemoveCoursePayload;
  /** admin */
  forceUpdateConstrainedChoiceSetting: ForceUpdateConstrainedChoiceSettingPayload;
  /** admin */
  liftSuspension: LiftSuspensionPayload;
  /** admin */
  lockStudentGroup: LockStudentGroupPayload;
  /** admin */
  marblesAuthoriseUser: MarblesAuthoriseUserMutationPayload;
  /** admin */
  marblesClearTokenCache: Scalars['Boolean']['output'];
  /** admin */
  marblesLiftSuspension: MarblesLiftSuspensionMutationPayload;
  /** admin */
  marblesRevokeAuthorisation: MarblesRevokeAuthorisationMutationPayload;
  /** admin */
  marblesSetNonAdminsToReadOnly: MutationStatus;
  /** admin */
  markPursuitsForDeregistration: MarkPursuitsForDeregistrationPayload;
  /** admin */
  processGroupSwap: ProcessGroupSwapPayload;
  /** admin */
  queueNotifications: QueueNotificationsPayload;
  /** admin */
  refreshCache: Scalars['Boolean']['output'];
  /** admin */
  registerStudentForCourse: RegisterStudentForCoursePayload;
  rejectCourseDescriptionsSubmission: RejectCourseDescriptionsSubmissionPayload;
  rejectCourseSubmission: RejectCourseSubmissionPayload;
  /** admin */
  rejectPendingCoursePursuit: RejectPendingCoursePursuitPayload;
  rejectTimetableConstraintsSubmission: RejectTimetableConstraintsSubmissionPayload;
  /** admin */
  removeApiKey: Scalars['Boolean']['output'];
  /** admin */
  removeConstrainedChoiceCluster: RemoveConstrainedChoiceClusterPayload;
  /** admin */
  removeInfoRequirement: RemoveInfoRequirementMutationPayload;
  /** student */
  removeMarblesCourse: RemoveMarblesCoursePayload;
  /** admin */
  removeRequiredCourses: RemoveRequiredCoursesMutationPayload;
  /** admin */
  removeRequiredPlan: RemoveRequiredPlanMutationPayload;
  /** admin */
  removeRequirement: RemoveRequirementMutationPayload;
  /** admin */
  removeRule: RemoveRuleMutationPayload;
  /** admin */
  removeTopic: RemoveTopicPayload;
  /** admin */
  removeTopicSet: RemoveTopicSetPayload;
  /** admin */
  replaceCourse: ReplaceCoursePayload;
  /** student */
  requestCourseRegistrationConfirmationEmail: RequestCourseRegistrationConfirmationEmailPayload;
  /** admin */
  resetCreditLimitExceptions: ResetCreditLimitExceptionsPayload;
  /** admin */
  revokeAuthorisation: RevokeAuthorisationPayload;
  /** student */
  selectCourseForRegistration: SelectCourseForRegistrationPayload;
  /** admin */
  semesterTransitionMutation: SemesterTransitionMutationPayload;
  /** admin */
  sendMail: SendMailOutput;
  /** admin */
  setCourseOfferingConstrainedChoiceCluster: SetCourseOfferingConstrainedChoiceClusterPayload;
  /** admin */
  setCourseOfferingCreditLimitException: SetCourseOfferingCreditLimitExceptionPayload;
  /** admin */
  setCourseOfferingRequirementNode: SetCourseOfferingRequirementNodePayload;
  /** admin */
  setCourseOfferingStatus: SetCourseOfferingStatusPayload;
  /** admin */
  setCourseOfferingTopicSet: SetCourseOfferingTopicSetPayload;
  /** admin */
  setCoursePursuitTopic: SetCoursePursuitTopicPayload;
  /** admin */
  setCreditLimitException: SetCreditLimitExceptionPayload;
  /** admin */
  setGroupSwapEnabled: SetGroupSwapEnabledPayload;
  /** admin */
  setNonAdminsToReadOnly: SetNonAdminsToReadOnlyPayload;
  /** admin */
  setStudentGroupCapacity: SetStudentGroupCapacityPayload;
  /** admin */
  setStudentGroupTopic: SetStudentGroupTopicPayload;
  /** admin */
  setStudentTimetablePreferences: SetStudentTimetablePreferencesPayload;
  /** student */
  setTimetablePreferences: SetTimetablePreferencesPayload;
  submitCourseDescriptionsDraft: SubmitCourseDescriptionsDraftPayload;
  submitCourseDraft: SubmitCourseDraftPayload;
  submitTimetableConstraintsDraft: SubmitTimetableConstraintsDraftPayload;
  /** admin */
  switchStudentGroup: SwitchStudentGroupPayload;
  syncResourcesToMagnifier: SyncResourcesPayload;
  /** admin */
  timeTravelTo: TimeTravelToPayload;
  /** admin */
  timeTravelToOffset: TimeTravelToPayload;
  /** admin */
  unlockStudentGroup: UnlockStudentGroupPayload;
  /** admin */
  updateConstrainedChoiceCluster: UpdateConstrainedChoiceClusterMutationPayload;
  /** student */
  updateConstrainedChoiceSetting: UpdateConstrainedChoiceSettingPayload;
  updateCourse: UpdateCoursePayload;
  updateCourseCatalogDescriptions: UpdateCourseCatalogDescriptionsPayload;
  updateCourseOfferingLecturers: UpdateCourseOfferingLecturersPayload;
  updateCourseOfferings: UpdateCourseOfferingsPayload;
  updateCourseSettings: UpdateCourseSettingsPayload;
  /** admin */
  updateInfoRequirement: UpdateInfoRequirementMutationPayload;
  /** admin */
  updateRequiredCareer: UpdateRequiredCareerMutationPayload;
  /** admin */
  updateRequiredCourses: UpdateRequiredCoursesMutationPayload;
  /** admin */
  updateRequiredPlan: UpdateRequiredPlanMutationPayload;
  /** admin */
  updateRequiredStudentSet: UpdateRequiredStudentSetMutationPayload;
  /** admin */
  updateRequirementName: UpdateRequirementNameMutationPayload;
  /** admin */
  updateRequirementRules: UpdateRequirementRulesMutationPayload;
  /** admin */
  updateRuleName: UpdateRuleNameMutationPayload;
  updateStudentGroups: UpdateStudentGroupsPayload;
  updateTimetableConstraints: UpdateTimetableConstraintsPayload;
  /** admin */
  updateTopic: UpdateTopicMutationPayload;
  /** admin */
  updateTopicSetName: UpdateTopicSetNameMutationPayload;
  /** admin */
  uploadBulkCourseDeregistrations: UploadBulkCourseDeregistrationsPayload;
  /** admin */
  uploadBulkCourseRegistrations: UploadBulkCourseRegistrationsPayload;
  /** admin */
  uploadCourseDeregistrations: UploadCourseDeregistrationsPayload;
  /** admin */
  uploadCoursePendingStudents: UploadCoursePendingStudentsPayload;
  /** admin */
  uploadCourseRegistrations: UploadCourseRegistrationsPayload;
  /** admin */
  uploadCreditLimitExceptions: UploadCreditLimitExceptionsPayload;
  /** admin */
  uploadGroupSettings: UploadGroupSettingsPayload;
  verifyCourseDescriptionsSubmission: VerifyCourseDescriptionsSubmissionPayload;
  verifyCourseSubmission: VerifyCourseSubmissionPayload;
  verifyTimetableConstraintsSubmission: VerifyTimetableConstraintsSubmissionPayload;
};

export type MutationAcceptPendingCoursePursuitArgs = {
  input: AcceptPendingCoursePursuitInput;
};

export type MutationAcknowledgeRejectedCourseArgs = {
  input: AcknowledgeRejectedCourseInput;
};

export type MutationAddApiKeyArgs = {
  input: AddApiKeyInput;
};

export type MutationAddInfoRequirementArgs = {
  input: AddInfoRequirementMutationInput;
};

export type MutationAddMarblesCourseArgs = {
  input: AddMarblesCourseInput;
};

export type MutationAddRequiredCoursesArgs = {
  input: AddRequiredCoursesMutationInput;
};

export type MutationAddRequiredPlanArgs = {
  input: AddRequiredPlanMutationInput;
};

export type MutationAddTopicArgs = {
  input: AddTopicMutationInput;
};

export type MutationAdministrativelySelectCourseForRegistrationArgs = {
  input: AdministrativelySelectCourseForRegistrationInput;
};

export type MutationAnnualTransitionCopyRequirementMutationArgs = {
  input: AnnualTransitionCopyRequirementsInput;
};

export type MutationAnnualTransitionMutationArgs = {
  input: AnnualTransitionMutationInput;
};

export type MutationAuthoriseUserArgs = {
  input: AuthoriseUserInput;
};

export type MutationBulkAcceptRejectCoursesArgs = {
  input: BulkAcceptRejectCoursesInput;
};

export type MutationBulkDeregisterMarkedPursuitsArgs = {
  deregisterNow: Scalars['Boolean']['input'];
  dryRun: Scalars['Boolean']['input'];
};

export type MutationBulkRejectInactiveStudentsArgs = {
  academicYear: Scalars['Int']['input'];
  dryRun: Scalars['Boolean']['input'];
};

export type MutationCancelGroupSwapRequestArgs = {
  input: CancelGroupSwapRequestInput;
};

export type MutationChangeCourseOwnerArgs = {
  input: ChangeCourseOwnerInput;
};

export type MutationClearCacheArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationClearTimetablePreferencesArgs = {
  input: ClearTimetablePreferencesInput;
};

export type MutationClearTokenCacheArgs = {
  input: ClearTokenCacheInput;
};

export type MutationCopyRequirementArgs = {
  input: CopyRequirementMutationInput;
};

export type MutationCopyRuleArgs = {
  input: CopyRuleMutationInput;
};

export type MutationCreateConstrainedChoiceClusterArgs = {
  input: CreateConstrainedChoiceClusterMutationInput;
};

export type MutationCreateCourseArgs = {
  input: CreateCourseInput;
};

export type MutationCreateGroupSwapRequestArgs = {
  input: CreateGroupSwapRequestInput;
};

export type MutationCreateRequirementArgs = {
  input: CreateRequirementMutationInput;
};

export type MutationCreateRuleRequiredCareerArgs = {
  input: CreateRuleRequiredCareerMutationInput;
};

export type MutationCreateRuleRequiredPlanArgs = {
  input: CreateRuleRequiredPlanMutationInput;
};

export type MutationCreateRuleRequiredStudentSetArgs = {
  input: CreateRuleRequiredStudentSetMutationInput;
};

export type MutationCreateTopicSetArgs = {
  input: CreateTopicSetMutationInput;
};

export type MutationDeregisterCourseArgs = {
  input: DeregisterCourseInput;
};

export type MutationDeregisterStudentForCourseArgs = {
  input: AdministrativelyDeregisterStudentForCourseInput;
};

export type MutationDeselectCourseForRegistrationArgs = {
  input: DeselectCourseForRegistrationInput;
};

export type MutationDirectRegisterForCourseArgs = {
  input: DirectRegisterForCourseInput;
};

export type MutationDummyAlgorithmArgs = {
  input: DummyAlgorithmInput;
};

export type MutationEnableDirectRegistrationArgs = {
  input: EnableDirectRegistrationInput;
};

export type MutationExecuteGroupSwapArgs = {
  input: ExecuteGroupSwapInput;
};

export type MutationFixCountersArgs = {
  courseOfferingId: Scalars['String']['input'];
};

export type MutationForceRemoveCourseArgs = {
  input: ForceRemoveCourseInput;
};

export type MutationForceUpdateConstrainedChoiceSettingArgs = {
  input: ForceUpdateConstrainedChoiceSettingInput;
};

export type MutationLiftSuspensionArgs = {
  input: LiftSuspensionInput;
};

export type MutationLockStudentGroupArgs = {
  input: LockStudentGroupInput;
};

export type MutationMarblesAuthoriseUserArgs = {
  input: MarblesAuthoriseUserMutationInput;
};

export type MutationMarblesClearTokenCacheArgs = {
  username?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMarblesLiftSuspensionArgs = {
  username: Scalars['String']['input'];
};

export type MutationMarblesRevokeAuthorisationArgs = {
  input: MarblesRevokeAuthorisationMutationInput;
};

export type MutationMarblesSetNonAdminsToReadOnlyArgs = {
  readOnly: Scalars['Boolean']['input'];
};

export type MutationMarkPursuitsForDeregistrationArgs = {
  dryRun: Scalars['Boolean']['input'];
};

export type MutationProcessGroupSwapArgs = {
  input: ProcessGroupSwapInput;
};

export type MutationQueueNotificationsArgs = {
  input: QueueNotificationsInput;
};

export type MutationRegisterStudentForCourseArgs = {
  input: RegisterStudentForCourseInput;
};

export type MutationRejectCourseDescriptionsSubmissionArgs = {
  input: RejectCourseDescriptionsSubmissionInput;
};

export type MutationRejectCourseSubmissionArgs = {
  input: RejectCourseSubmissionInput;
};

export type MutationRejectPendingCoursePursuitArgs = {
  input: RejectPendingCoursePursuitInput;
};

export type MutationRejectTimetableConstraintsSubmissionArgs = {
  input: RejectTimetableConstraintsSubmissionInput;
};

export type MutationRemoveApiKeyArgs = {
  username: Scalars['String']['input'];
};

export type MutationRemoveConstrainedChoiceClusterArgs = {
  input: RemoveConstrainedChoiceClusterInput;
};

export type MutationRemoveInfoRequirementArgs = {
  input: RemoveInfoRequirementMutationInput;
};

export type MutationRemoveMarblesCourseArgs = {
  input: RemoveMarblesCourseInput;
};

export type MutationRemoveRequiredCoursesArgs = {
  input: RemoveRequiredCoursesMutationInput;
};

export type MutationRemoveRequiredPlanArgs = {
  input: RemoveRequiredPlanMutationInput;
};

export type MutationRemoveRequirementArgs = {
  input: RemoveRequirementMutationInput;
};

export type MutationRemoveRuleArgs = {
  input: RemoveRuleMutationInput;
};

export type MutationRemoveTopicArgs = {
  input: RemoveTopicInput;
};

export type MutationRemoveTopicSetArgs = {
  input: RemoveTopicSetInput;
};

export type MutationReplaceCourseArgs = {
  input: ReplaceCourseInput;
};

export type MutationResetCreditLimitExceptionsArgs = {
  dryRun: Scalars['Boolean']['input'];
};

export type MutationRevokeAuthorisationArgs = {
  input: RevokeAuthorisationInput;
};

export type MutationSelectCourseForRegistrationArgs = {
  input: SelectCourseForRegistrationInput;
};

export type MutationSemesterTransitionMutationArgs = {
  input: SemesterTransitionMutationInput;
};

export type MutationSendMailArgs = {
  input: SendMailInput;
};

export type MutationSetCourseOfferingConstrainedChoiceClusterArgs = {
  input: SetCourseOfferingConstrainedChoiceClusterInput;
};

export type MutationSetCourseOfferingCreditLimitExceptionArgs = {
  input: SetCourseOfferingCreditLimitExceptionInput;
};

export type MutationSetCourseOfferingRequirementNodeArgs = {
  input: SetCourseOfferingRequirementNodeInput;
};

export type MutationSetCourseOfferingStatusArgs = {
  input: SetCourseOfferingStatusInput;
};

export type MutationSetCourseOfferingTopicSetArgs = {
  input: SetCourseOfferingTopicSetInput;
};

export type MutationSetCoursePursuitTopicArgs = {
  input: SetCoursePursuitTopicInput;
};

export type MutationSetCreditLimitExceptionArgs = {
  input: SetCreditLimitExceptionInput;
};

export type MutationSetGroupSwapEnabledArgs = {
  input: SetGroupSwapEnabledInput;
};

export type MutationSetNonAdminsToReadOnlyArgs = {
  input: SetNonAdminsToReadOnlyInput;
};

export type MutationSetStudentGroupCapacityArgs = {
  input: SetStudentGroupCapacityInput;
};

export type MutationSetStudentGroupTopicArgs = {
  input: SetStudentGroupTopicInput;
};

export type MutationSetStudentTimetablePreferencesArgs = {
  input: SetStudentTimetablePreferencesInput;
};

export type MutationSetTimetablePreferencesArgs = {
  input: SetTimetablePreferencesInput;
};

export type MutationSubmitCourseDescriptionsDraftArgs = {
  input: SubmitCourseDescriptionsInput;
};

export type MutationSubmitCourseDraftArgs = {
  input: SubmitCourseDraftInput;
};

export type MutationSubmitTimetableConstraintsDraftArgs = {
  input: SubmitTimetableConstraintsDraftInput;
};

export type MutationSwitchStudentGroupArgs = {
  input: SwitchStudentGroupInput;
};

export type MutationSyncResourcesToMagnifierArgs = {
  input: SyncResourcesToMagnifierInput;
};

export type MutationTimeTravelToArgs = {
  beforeOrAfter: BeforeOrAfter;
  minutes: Scalars['Int']['input'];
  moment: RegistrationRoundMoment;
  registrationRoundId: Scalars['String']['input'];
};

export type MutationTimeTravelToOffsetArgs = {
  offsetTicks: Scalars['Long']['input'];
};

export type MutationUnlockStudentGroupArgs = {
  input: UnlockStudentGroupInput;
};

export type MutationUpdateConstrainedChoiceClusterArgs = {
  input: UpdateConstrainedChoiceClusterMutationInput;
};

export type MutationUpdateConstrainedChoiceSettingArgs = {
  input: UpdateConstrainedChoiceSettingInput;
};

export type MutationUpdateCourseArgs = {
  input: UpdateCourseInput;
};

export type MutationUpdateCourseCatalogDescriptionsArgs = {
  input: UpdateCourseCatalogDescriptionsInput;
};

export type MutationUpdateCourseOfferingLecturersArgs = {
  input: UpdateCourseOfferingLecturersInput;
};

export type MutationUpdateCourseOfferingsArgs = {
  input: UpdateCourseOfferingsInput;
};

export type MutationUpdateCourseSettingsArgs = {
  input: UpdateCourseSettingsInput;
};

export type MutationUpdateInfoRequirementArgs = {
  input: UpdateInfoRequirementMutationInput;
};

export type MutationUpdateRequiredCareerArgs = {
  input: UpdateRequiredCareerMutationInput;
};

export type MutationUpdateRequiredCoursesArgs = {
  input: UpdateRequiredCoursesMutationInput;
};

export type MutationUpdateRequiredPlanArgs = {
  input: UpdateRequiredPlanMutationInput;
};

export type MutationUpdateRequiredStudentSetArgs = {
  input: UpdateRequiredStudentSetMutationInput;
};

export type MutationUpdateRequirementNameArgs = {
  input: UpdateRequirementNameMutationInput;
};

export type MutationUpdateRequirementRulesArgs = {
  input: UpdateRequirementRulesMutationInput;
};

export type MutationUpdateRuleNameArgs = {
  input: UpdateRuleNameMutationInput;
};

export type MutationUpdateStudentGroupsArgs = {
  input: UpdateStudentGroupsInput;
};

export type MutationUpdateTimetableConstraintsArgs = {
  input: UpdateTimetableConstraintsInput;
};

export type MutationUpdateTopicArgs = {
  input: UpdateTopicMutationInput;
};

export type MutationUpdateTopicSetNameArgs = {
  input: UpdateTopicSetNameMutationInput;
};

export type MutationUploadBulkCourseDeregistrationsArgs = {
  input: UploadBulkCourseDeregistrationsInput;
};

export type MutationUploadBulkCourseRegistrationsArgs = {
  input: UploadBulkCourseRegistrationsInput;
};

export type MutationUploadCourseDeregistrationsArgs = {
  input: UploadCourseDeregistrationsInput;
};

export type MutationUploadCoursePendingStudentsArgs = {
  input: UploadCoursePendingStudentsInput;
};

export type MutationUploadCourseRegistrationsArgs = {
  input: UploadCourseRegistrationsInput;
};

export type MutationUploadCreditLimitExceptionsArgs = {
  input: UploadCreditLimitExceptionsInput;
};

export type MutationUploadGroupSettingsArgs = {
  input: UploadGroupSettingsInput;
};

export type MutationVerifyCourseDescriptionsSubmissionArgs = {
  input: VerifyCourseDescriptionsSubmissionInput;
};

export type MutationVerifyCourseSubmissionArgs = {
  input: VerifyCourseSubmissionInput;
};

export type MutationVerifyTimetableConstraintsSubmissionArgs = {
  input: VerifyTimetableConstraintsSubmissionInput;
};

export enum MutationStatus {
  AcademicYearArchived = 'ACADEMIC_YEAR_ARCHIVED',
  CannotRemoveLastCourseOffering = 'CANNOT_REMOVE_LAST_COURSE_OFFERING',
  CareerNotFound = 'CAREER_NOT_FOUND',
  ClusterFull = 'CLUSTER_FULL',
  ClusterLimitExceedsPursuits = 'CLUSTER_LIMIT_EXCEEDS_PURSUITS',
  ClusterMaxLimitExceeded = 'CLUSTER_MAX_LIMIT_EXCEEDED',
  ConstrainedChoiceClusterNotFound = 'CONSTRAINED_CHOICE_CLUSTER_NOT_FOUND',
  Corrupt = 'CORRUPT',
  CourseCodeDuplicate = 'COURSE_CODE_DUPLICATE',
  CourseNotFound = 'COURSE_NOT_FOUND',
  CourseOfferingAmbivalent = 'COURSE_OFFERING_AMBIVALENT',
  CourseOfferingCreditLimitException = 'COURSE_OFFERING_CREDIT_LIMIT_EXCEPTION',
  CourseOfferingInactive = 'COURSE_OFFERING_INACTIVE',
  CourseOfferingNotFound = 'COURSE_OFFERING_NOT_FOUND',
  CourseOfferingPendingPursuits = 'COURSE_OFFERING_PENDING_PURSUITS',
  CourseOfferingPeriodsOverlap = 'COURSE_OFFERING_PERIODS_OVERLAP',
  CreditLimitExceeded = 'CREDIT_LIMIT_EXCEEDED',
  Duplicate = 'DUPLICATE',
  Error = 'ERROR',
  GroupFull = 'GROUP_FULL',
  GroupNotFound = 'GROUP_NOT_FOUND',
  Inactive = 'INACTIVE',
  InvalidDepartment = 'INVALID_DEPARTMENT',
  LecturerNotFound = 'LECTURER_NOT_FOUND',
  Locked = 'LOCKED',
  MaximumReached = 'MAXIMUM_REACHED',
  NotFound = 'NOT_FOUND',
  NoActiveEnrolment = 'NO_ACTIVE_ENROLMENT',
  PlanNotFound = 'PLAN_NOT_FOUND',
  ProgrammeNotFound = 'PROGRAMME_NOT_FOUND',
  PursuitDuplicatePending = 'PURSUIT_DUPLICATE_PENDING',
  PursuitDuplicateRegistered = 'PURSUIT_DUPLICATE_REGISTERED',
  PursuitNotFound = 'PURSUIT_NOT_FOUND',
  RegistrationClosed = 'REGISTRATION_CLOSED',
  RequirementsNotMet = 'REQUIREMENTS_NOT_MET',
  RequirementNotAvailable = 'REQUIREMENT_NOT_AVAILABLE',
  RequirementNotFound = 'REQUIREMENT_NOT_FOUND',
  StudentGroupCapacityOutOfRange = 'STUDENT_GROUP_CAPACITY_OUT_OF_RANGE',
  StudentGroupCodeDuplicate = 'STUDENT_GROUP_CODE_DUPLICATE',
  StudentGroupCodeInvalid = 'STUDENT_GROUP_CODE_INVALID',
  StudentGroupNameInvalid = 'STUDENT_GROUP_NAME_INVALID',
  StudentGroupNotFound = 'STUDENT_GROUP_NOT_FOUND',
  StudentNotFound = 'STUDENT_NOT_FOUND',
  StudentSetNotFound = 'STUDENT_SET_NOT_FOUND',
  SubplanNotFound = 'SUBPLAN_NOT_FOUND',
  Success = 'SUCCESS',
  TimetableConstraintsNotFound = 'TIMETABLE_CONSTRAINTS_NOT_FOUND',
  TopicHasPendingPursuit = 'TOPIC_HAS_PENDING_PURSUIT',
  TopicMissing = 'TOPIC_MISSING',
  TopicNotFound = 'TOPIC_NOT_FOUND',
  TopicSetNotConfigured = 'TOPIC_SET_NOT_CONFIGURED',
  TopicSetNotFound = 'TOPIC_SET_NOT_FOUND',
  Unauthorized = 'UNAUTHORIZED',
  UploadMissingColumns = 'UPLOAD_MISSING_COLUMNS',
  UserSuspended = 'USER_SUSPENDED',
  ValidationStepNotFound = 'VALIDATION_STEP_NOT_FOUND',
}

export enum NotificationType {
  AllocationResult = 'ALLOCATION_RESULT',
  CourseRegistrationConfirmation = 'COURSE_REGISTRATION_CONFIRMATION',
  GroupSwapExpired = 'GROUP_SWAP_EXPIRED',
  GroupSwapSuccess = 'GROUP_SWAP_SUCCESS',
  SurveyInvite = 'SURVEY_INVITE',
}

export enum PendingOrRegistered {
  Pending = 'PENDING',
  PendingRegistered = 'PENDING_REGISTERED',
  Registered = 'REGISTERED',
  Rejected = 'REJECTED',
}

export type Period = {
  __typename?: 'Period';
  academicYear: MarblesAcademicYear;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  periodInSemester: Scalars['Int']['output'];
  semester: Semester;
  semesterNumber: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type Plan = {
  __typename?: 'Plan';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  subplans: Array<Subplan>;
};

export type ProcessGroupSwapInput = {
  groupSwapRequestId: Scalars['String']['input'];
  studentGroupId: Scalars['String']['input'];
};

export type ProcessGroupSwapPayload = {
  __typename?: 'ProcessGroupSwapPayload';
  groupSwapRequest?: Maybe<GroupSwapRequest>;
  mutationStatus: MutationStatus;
  studentGroups: Array<StudentGroup>;
};

export type Programme = {
  code: Scalars['String']['output'];
  courseCodePrefix: Scalars['String']['output'];
  department: Department;
  description: BilingualString;
  id: Scalars['String']['output'];
  programmeType: ProgrammeType;
};

export enum ProgrammeType {
  Administrative = 'ADMINISTRATIVE',
  Certificate = 'CERTIFICATE',
  Degree = 'DEGREE',
}

export type PursuitDiagnostics = {
  __typename?: 'PursuitDiagnostics';
  allClusterSettings: Array<ConstrainedChoiceClusterSetting>;
  clusterSettingIds: Array<Scalars['String']['output']>;
  pursuitId: Scalars['String']['output'];
  status?: Maybe<CoursePursuitStatus>;
  studentId: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  academicYear: AcademicYear;
  academicYears: Array<AcademicYear>;
  authorisableUser: User;
  authorisableUsers: Array<User>;
  authorisationRights: AuthorisationRights;
  benchmarkCourseOfferingRequirements?: Maybe<BenchmarkResults>;
  careers: Array<Career>;
  checkUniqueCourseCode: Scalars['Boolean']['output'];
  constrainedChoiceCluster?: Maybe<ConstrainedChoiceCluster>;
  constrainedChoiceClusterSettings: Array<ConstrainedChoiceClusterSetting>;
  constrainedChoiceClusters: Array<ConstrainedChoiceCluster>;
  courseByCode: Course;
  /** @deprecated Use getCourseByCode instead */
  courseById: Course;
  courseCatalogDescriptionsByCourseId: CourseCatalogDescriptions;
  courseOfferingByNumber: CourseOffering;
  courseOfferingGroupSwaps: Array<GroupSwapRequest>;
  courseOfferingPendingGroupSwaps: Array<CourseOfferingPendingGroupSwap>;
  courseOfferingPursuits: Array<CoursePursuit>;
  courseOfferingRejections: Array<Rejection>;
  courseOfferingRequirementCapacity: Array<CourseOfferingRequirementCapacity>;
  courseOfferingRequirementCheck?: Maybe<Requirements>;
  courseOfferingRequirementsExport: DownloadLink;
  courseOfferingSwappableGroups: Array<SwappableStudentGroup>;
  courseOfferingTimetableActivities: Array<TimetableActivity>;
  courseOfferingTopicsCapacityQuery: Array<CourseOfferingTopicCapacity>;
  courseOfferingsExport: DownloadLink;
  coursePursuit?: Maybe<CoursePursuit>;
  coursePursuitRequirements?: Maybe<Requirements>;
  coursePursuits: Array<CoursePursuit>;
  courseRegistrationsExport: DownloadLink;
  coursesByProgrammeCode: Array<Course>;
  /** @deprecated Use getCoursesByProgrammeCode instead */
  coursesByProgrammeId: Array<Course>;
  departmentById: Department;
  departments: Array<Department>;
  diagnostics: Array<Diagnostic>;
  groupSwapRequest?: Maybe<GroupSwapRequest>;
  maintenanceMessages: Array<MaintenanceMessage>;
  marblesAcademicYears: Array<MarblesAcademicYear>;
  marblesAuthorisationRights: MarblesAuthorisationRights;
  marblesCourseInfo?: Maybe<MarblesCourseInfo>;
  marblesCourseOffering?: Maybe<MarblesCourseOffering>;
  marblesCourseOfferings: Array<MarblesCourseOffering>;
  marblesCourses: MarblesCourseSearchResult;
  marblesDepartments: Array<MarblesDepartment>;
  marblesMaintenanceMessages: Array<MaintenanceMessage>;
  /** me */
  marblesMe: UserProfile;
  marblesUser: MarblesUser;
  marblesUsers: Array<MarblesUser>;
  /** me */
  me: UserProfile;
  periods: Array<Period>;
  plan?: Maybe<Plan>;
  programmeByCode: Programme;
  /** @deprecated Use getProgrammeByCode instead */
  programmeById: Programme;
  /** @deprecated Use getProgrammesByDepartmentCode instead */
  programmes: Array<Programme>;
  programmesByDepartmentCode: Array<Programme>;
  /** admin */
  pursuitDiagnostics: PursuitDiagnostics;
  registrationRoundStatistics: RegistrationRoundStatistics;
  registrationRounds: Array<RegistrationRound>;
  removedCourses: Array<Course>;
  requirement?: Maybe<Requirement>;
  requirementCopyDepartments: Array<MarblesDepartment>;
  requirements: Array<Requirement>;
  rule?: Maybe<Rule>;
  rules: Array<Rule>;
  searchUsers: Array<User>;
  semesters: Array<Semester>;
  student?: Maybe<Student>;
  studentGroup?: Maybe<StudentGroup>;
  studentGroupSwaps: Array<GroupSwapRequest>;
  studentGroups: Array<StudentGroup>;
  studentGroupsExport: DownloadLink;
  studentPursuitAudit: Array<CoursePursuitAudit>;
  studentPursuits: Array<CoursePursuit>;
  studentRequirementsCheck?: Maybe<StudentRequirementsCheckPayload>;
  studentSet?: Maybe<StudentSet>;
  studentSets: Array<StudentSet>;
  studentTimetableActivities: Array<TimetableActivity>;
  students: StudentSearchResult;
  timetablePreferences: TimetablePreferences;
  topicSet?: Maybe<TopicSet>;
  topicSetCreateDepartments: Array<MarblesDepartment>;
  topicSets: Array<TopicSet>;
};

export type QueryAcademicYearArgs = {
  year: Scalars['Int']['input'];
};

export type QueryAuthorisableUserArgs = {
  username: Scalars['String']['input'];
};

export type QueryBenchmarkCourseOfferingRequirementsArgs = {
  courseOfferingId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCheckUniqueCourseCodeArgs = {
  academicYear: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  level: CourseLevel;
  programmeId: Scalars['String']['input'];
};

export type QueryConstrainedChoiceClusterArgs = {
  constrainedChoiceClusterId: Scalars['String']['input'];
};

export type QueryConstrainedChoiceClustersArgs = {
  academicYear?: InputMaybe<Scalars['Int']['input']>;
  departmentId: Scalars['String']['input'];
};

export type QueryCourseByCodeArgs = {
  academicYear: Scalars['Int']['input'];
  code: Scalars['String']['input'];
};

export type QueryCourseByIdArgs = {
  academicYear: Scalars['Int']['input'];
  courseId: Scalars['String']['input'];
};

export type QueryCourseCatalogDescriptionsByCourseIdArgs = {
  academicYear: Scalars['Int']['input'];
  courseId: Scalars['String']['input'];
};

export type QueryCourseOfferingByNumberArgs = {
  academicYear: Scalars['Int']['input'];
  courseCode: Scalars['String']['input'];
  offeringNumber: Scalars['Int']['input'];
};

export type QueryCourseOfferingGroupSwapsArgs = {
  courseOfferingId: Scalars['String']['input'];
};

export type QueryCourseOfferingPendingGroupSwapsArgs = {
  academicYear: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
};

export type QueryCourseOfferingPursuitsArgs = {
  courseOfferingId: Scalars['String']['input'];
  status?: InputMaybe<CoursePursuitStatus>;
};

export type QueryCourseOfferingRejectionsArgs = {
  courseOfferingId: Scalars['String']['input'];
};

export type QueryCourseOfferingRequirementCapacityArgs = {
  courseOfferingId: Scalars['String']['input'];
};

export type QueryCourseOfferingRequirementCheckArgs = {
  courseOfferingId: Scalars['String']['input'];
};

export type QueryCourseOfferingRequirementsExportArgs = {
  academicYear?: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
  language?: Language;
};

export type QueryCourseOfferingSwappableGroupsArgs = {
  courseOfferingId: Scalars['String']['input'];
};

export type QueryCourseOfferingTimetableActivitiesArgs = {
  courseOfferingId: Scalars['String']['input'];
};

export type QueryCourseOfferingTopicsCapacityQueryArgs = {
  courseOfferingId: Scalars['String']['input'];
};

export type QueryCourseOfferingsExportArgs = {
  academicYear?: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
  language?: Language;
};

export type QueryCoursePursuitArgs = {
  coursePursuitId: Scalars['String']['input'];
};

export type QueryCoursePursuitRequirementsArgs = {
  coursePursuitId: Scalars['String']['input'];
};

export type QueryCoursePursuitsArgs = {
  semesterId: Scalars['String']['input'];
};

export type QueryCourseRegistrationsExportArgs = {
  academicYear?: InputMaybe<Scalars['Int']['input']>;
  courseOfferingId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  language?: Language;
  status: PendingOrRegistered;
};

export type QueryCoursesByProgrammeCodeArgs = {
  academicYear: Scalars['Int']['input'];
  programmeCode: Scalars['String']['input'];
};

export type QueryCoursesByProgrammeIdArgs = {
  academicYear: Scalars['Int']['input'];
  programmeId: Scalars['String']['input'];
};

export type QueryDepartmentByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryGroupSwapRequestArgs = {
  id: Scalars['String']['input'];
};

export type QueryMarblesCourseInfoArgs = {
  catalogNumber?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMarblesCourseOfferingArgs = {
  courseOfferingId: Scalars['String']['input'];
};

export type QueryMarblesCourseOfferingsArgs = {
  academicYear?: Scalars['Int']['input'];
  catalogNumber?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['String']['input'];
};

export type QueryMarblesCoursesArgs = {
  academicYear?: Scalars['Int']['input'];
  language?: Language;
  query: Scalars['String']['input'];
};

export type QueryMarblesUserArgs = {
  username: Scalars['String']['input'];
};

export type QueryPlanArgs = {
  planCode?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProgrammeByCodeArgs = {
  academicYear: Scalars['Int']['input'];
  code: Scalars['String']['input'];
};

export type QueryProgrammeByIdArgs = {
  academicYear: Scalars['Int']['input'];
  id: Scalars['String']['input'];
};

export type QueryProgrammesArgs = {
  academicYear: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
  programmeType: ProgrammeType;
};

export type QueryProgrammesByDepartmentCodeArgs = {
  academicYear: Scalars['Int']['input'];
  departmentCode: Scalars['String']['input'];
  programmeType: ProgrammeType;
};

export type QueryPursuitDiagnosticsArgs = {
  pursuitId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};

export type QueryRegistrationRoundStatisticsArgs = {
  permits: Scalars['Long']['input'];
  roundId: Scalars['String']['input'];
  startFrom: Scalars['Long']['input'];
};

export type QueryRegistrationRoundsArgs = {
  academicYear?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRemovedCoursesArgs = {
  academicYear: Scalars['Int']['input'];
  language: Language;
  programmeId: Scalars['String']['input'];
  query: Scalars['String']['input'];
};

export type QueryRequirementArgs = {
  requirementId: Scalars['String']['input'];
};

export type QueryRequirementCopyDepartmentsArgs = {
  requirementId: Scalars['String']['input'];
};

export type QueryRequirementsArgs = {
  academicYear?: InputMaybe<Scalars['Int']['input']>;
  departmentId: Scalars['String']['input'];
  includeParentDepartments: Scalars['Boolean']['input'];
};

export type QueryRuleArgs = {
  ruleId: Scalars['String']['input'];
};

export type QueryRulesArgs = {
  academicYear: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
  includeParentDepartments?: Scalars['Boolean']['input'];
};

export type QuerySearchUsersArgs = {
  search: Scalars['String']['input'];
};

export type QueryStudentArgs = {
  studentId?: InputMaybe<Scalars['String']['input']>;
  studentNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryStudentGroupArgs = {
  studentGroupId: Scalars['String']['input'];
};

export type QueryStudentGroupSwapsArgs = {
  studentId: Scalars['String']['input'];
};

export type QueryStudentGroupsArgs = {
  academicYear?: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
};

export type QueryStudentGroupsExportArgs = {
  academicYear?: InputMaybe<Scalars['Int']['input']>;
  courseOfferingId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  language?: Language;
};

export type QueryStudentPursuitAuditArgs = {
  studentId: Scalars['String']['input'];
};

export type QueryStudentPursuitsArgs = {
  studentId: Scalars['String']['input'];
};

export type QueryStudentRequirementsCheckArgs = {
  courseOfferingId: Scalars['String']['input'];
  studentId?: InputMaybe<Scalars['String']['input']>;
  studentNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryStudentSetArgs = {
  code: Scalars['String']['input'];
};

export type QueryStudentTimetableActivitiesArgs = {
  studentId: Scalars['String']['input'];
};

export type QueryStudentsArgs = {
  query: Scalars['String']['input'];
};

export type QueryTopicSetArgs = {
  topicSetId: Scalars['String']['input'];
};

export type QueryTopicSetCreateDepartmentsArgs = {
  departmentId: Scalars['String']['input'];
};

export type QueryTopicSetsArgs = {
  academicYear?: Scalars['Int']['input'];
  departmentId: Scalars['String']['input'];
};

export type QueueNotificationsInput = {
  maxMailsPerMinute: Scalars['Int']['input'];
  notificationType: NotificationType;
  plannedNotificationDate: Scalars['DateTime']['input'];
  studentIds: Array<Scalars['String']['input']>;
};

export type QueueNotificationsPayload = {
  __typename?: 'QueueNotificationsPayload';
  issues: Array<QueueNotificationsPayloadIssue>;
  lastPlannedNotificationDate: Scalars['DateTime']['output'];
  mutationStatus: MutationStatus;
  notificationCount: Scalars['Int']['output'];
};

export type QueueNotificationsPayloadIssue = {
  __typename?: 'QueueNotificationsPayloadIssue';
  message: Scalars['String']['output'];
  studentId: Scalars['String']['output'];
};

export type RegisterStudentForCourseInput = {
  courseOfferingId: Scalars['String']['input'];
  skipRequirements: Scalars['Boolean']['input'];
  studentGroupId: Scalars['String']['input'];
  studentId: Scalars['String']['input'];
};

export type RegisterStudentForCoursePayload = {
  __typename?: 'RegisterStudentForCoursePayload';
  courseOfferingId?: Maybe<Scalars['String']['output']>;
  coursePursuitId?: Maybe<Scalars['String']['output']>;
  mutationStatus: MutationStatus;
  reason?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['DateTime']['output']>;
  requirementsCheck?: Maybe<Requirements>;
  student?: Maybe<Student>;
  studentGroup?: Maybe<StudentGroup>;
  studentGroupId?: Maybe<Scalars['String']['output']>;
};

export type RegistrationRound = {
  __typename?: 'RegistrationRound';
  academicYear: MarblesAcademicYear;
  description: BilingualString;
  id: Scalars['String']['output'];
  label?: Maybe<BilingualString>;
  periods: Array<Period>;
  registrationEndDate: Scalars['DateTime']['output'];
  registrationResultDate: Scalars['DateTime']['output'];
  registrationRoundType: RegistrationRoundType;
  registrationStartDate: Scalars['DateTime']['output'];
  semesters: Array<Semester>;
  showCapacity: Scalars['Boolean']['output'];
};

export type RegistrationRoundCreditStatistics = {
  __typename?: 'RegistrationRoundCreditStatistics';
  creditsAllocated: Scalars['Float']['output'];
  creditsRequested: Scalars['Float']['output'];
  studentId: Scalars['String']['output'];
};

export enum RegistrationRoundMoment {
  RegistrationEndDate = 'REGISTRATION_END_DATE',
  RegistrationResultDate = 'REGISTRATION_RESULT_DATE',
  RegistrationStartDate = 'REGISTRATION_START_DATE',
}

export type RegistrationRoundPursuitStatistics = {
  __typename?: 'RegistrationRoundPursuitStatistics';
  courseId: Scalars['String']['output'];
  courseOfferingOfferingId: Scalars['String']['output'];
  credits: Scalars['Float']['output'];
  department: Scalars['String']['output'];
  faculty: Scalars['String']['output'];
  pursuitId: Scalars['String']['output'];
  registeredBy?: Maybe<Scalars['String']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  studentId: Scalars['String']['output'];
};

export type RegistrationRoundStatistics = {
  __typename?: 'RegistrationRoundStatistics';
  credits: Array<RegistrationRoundCreditStatistics>;
  firstEventId?: Maybe<Scalars['Long']['output']>;
  lastEventId?: Maybe<Scalars['Long']['output']>;
  pursuits: Array<RegistrationRoundPursuitStatistics>;
};

export enum RegistrationRoundType {
  LateRegistration = 'LATE_REGISTRATION',
  Regular = 'REGULAR',
}

export type RejectCourseDescriptionsSubmissionInput = {
  academicYear: Scalars['Int']['input'];
  courseId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  stepId: Scalars['String']['input'];
};

export type RejectCourseDescriptionsSubmissionPayload = {
  __typename?: 'RejectCourseDescriptionsSubmissionPayload';
  course?: Maybe<Course>;
  mutationStatus: MutationStatus;
};

export type RejectCourseSubmissionInput = {
  academicYear: Scalars['Int']['input'];
  courseId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  stepId: Scalars['String']['input'];
};

export type RejectCourseSubmissionPayload = {
  __typename?: 'RejectCourseSubmissionPayload';
  course?: Maybe<Course>;
  mutationStatus: MutationStatus;
};

export type RejectPendingCoursePursuitInput = {
  coursePursuitId: Scalars['String']['input'];
};

export type RejectPendingCoursePursuitPayload = {
  __typename?: 'RejectPendingCoursePursuitPayload';
  courseOfferingId?: Maybe<Scalars['String']['output']>;
  coursePursuitId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
};

export type RejectTimetableConstraintsSubmissionInput = {
  courseOfferingId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  stepId: Scalars['String']['input'];
  timetableConstraintsInput: TimetableConstraintsInput;
};

export type RejectTimetableConstraintsSubmissionPayload = {
  __typename?: 'RejectTimetableConstraintsSubmissionPayload';
  mutationStatus: MutationStatus;
  timetableConstraints?: Maybe<TimetableConstraints>;
};

export type Rejection = {
  __typename?: 'Rejection';
  id: Scalars['String']['output'];
  registrationRound?: Maybe<RegistrationRound>;
  rejectionDate: Scalars['DateTime']['output'];
  rejectionReason?: Maybe<RejectionReason>;
  student: Student;
  topic?: Maybe<Topic>;
  username: Scalars['String']['output'];
};

export enum RejectionReason {
  AtCapacity = 'AT_CAPACITY',
  Other = 'OTHER',
  PreferredCourseAllocated = 'PREFERRED_COURSE_ALLOCATED',
}

export type RemoveConstrainedChoiceClusterInput = {
  constrainedChoiceClusterId: Scalars['String']['input'];
};

export type RemoveConstrainedChoiceClusterPayload = {
  __typename?: 'RemoveConstrainedChoiceClusterPayload';
  constrainedChoiceClusterId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
};

export type RemoveInfoRequirementMutationInput = {
  nodeId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
};

export type RemoveInfoRequirementMutationPayload = {
  __typename?: 'RemoveInfoRequirementMutationPayload';
  mutationStatus: MutationStatus;
  nodeId: Scalars['String']['output'];
  rule?: Maybe<Rule>;
};

export type RemoveMarblesCourseInput = {
  coursePursuitId: Scalars['String']['input'];
};

export type RemoveMarblesCoursePayload = {
  __typename?: 'RemoveMarblesCoursePayload';
  coursePursuitId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
};

export type RemoveRequiredCoursesMutationInput = {
  nodeId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
};

export type RemoveRequiredCoursesMutationPayload = {
  __typename?: 'RemoveRequiredCoursesMutationPayload';
  mutationStatus: MutationStatus;
  nodeId: Scalars['String']['output'];
  rule?: Maybe<Rule>;
};

export type RemoveRequiredPlanMutationInput = {
  nodeId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
};

export type RemoveRequiredPlanMutationPayload = {
  __typename?: 'RemoveRequiredPlanMutationPayload';
  mutationStatus: MutationStatus;
  nodeId: Scalars['String']['output'];
  rule?: Maybe<Rule>;
};

export type RemoveRequirementMutationInput = {
  requirementId: Scalars['String']['input'];
};

export type RemoveRequirementMutationPayload = {
  __typename?: 'RemoveRequirementMutationPayload';
  academicYear?: Maybe<Scalars['Int']['output']>;
  departmentId?: Maybe<Scalars['String']['output']>;
  mutationStatus: MutationStatus;
  requirementId: Scalars['String']['output'];
};

export type RemoveRuleMutationInput = {
  ruleId: Scalars['String']['input'];
};

export type RemoveRuleMutationPayload = {
  __typename?: 'RemoveRuleMutationPayload';
  academicYear?: Maybe<Scalars['Int']['output']>;
  departmentId?: Maybe<Scalars['String']['output']>;
  mutationStatus: MutationStatus;
  ruleId: Scalars['String']['output'];
};

export type RemoveTopicInput = {
  topicId: Scalars['String']['input'];
};

export type RemoveTopicPayload = {
  __typename?: 'RemoveTopicPayload';
  mutationStatus: MutationStatus;
  topicId: Scalars['String']['output'];
  topicSetId?: Maybe<Scalars['String']['output']>;
};

export type RemoveTopicSetInput = {
  topicSetId: Scalars['String']['input'];
};

export type RemoveTopicSetPayload = {
  __typename?: 'RemoveTopicSetPayload';
  mutationStatus: MutationStatus;
  topicSetId: Scalars['String']['output'];
};

export type ReplaceCourseInput = {
  newCourseId: Scalars['String']['input'];
  oldCourseId: Scalars['String']['input'];
};

export type ReplaceCoursePayload = {
  __typename?: 'ReplaceCoursePayload';
  count: Scalars['Int']['output'];
};

export type RequestCourseRegistrationConfirmationEmailPayload = {
  __typename?: 'RequestCourseRegistrationConfirmationEmailPayload';
  mutationStatus: MutationStatus;
};

export type RequiredCareer = GroupRequirementNode & {
  __typename?: 'RequiredCareer';
  careers: Array<Career>;
  description: BilingualString;
  id: Scalars['String']['output'];
  type: RequirementNodeType;
};

export type RequiredCourses = RequirementNode & {
  __typename?: 'RequiredCourses';
  courses: Array<MarblesCourseInfo>;
  description: BilingualString;
  id: Scalars['String']['output'];
  requiredCourses?: Maybe<Scalars['Int']['output']>;
  requiredCredits?: Maybe<Scalars['Float']['output']>;
  requirement: RequiredCoursesRequirement;
  type: RequirementNodeType;
};

export type RequiredCoursesInput = {
  courseIds: Array<Scalars['String']['input']>;
  requiredCourses?: InputMaybe<Scalars['Int']['input']>;
  requiredCredits?: InputMaybe<Scalars['Float']['input']>;
  requirement: RequiredCoursesRequirement;
};

export enum RequiredCoursesRequirement {
  AllCourses = 'ALL_COURSES',
  MinimumCourses = 'MINIMUM_COURSES',
  MinimumCredits = 'MINIMUM_CREDITS',
}

export type RequiredPlan = GroupRequirementNode & {
  __typename?: 'RequiredPlan';
  description: BilingualString;
  id: Scalars['String']['output'];
  plan: Plan;
  subplans?: Maybe<Array<Subplan>>;
  type: RequirementNodeType;
};

export type RequiredPlanInput = {
  planId: Scalars['String']['input'];
  subplanIds: Array<Scalars['String']['input']>;
};

export type RequiredStudentSet = GroupRequirementNode & {
  __typename?: 'RequiredStudentSet';
  description: BilingualString;
  id: Scalars['String']['output'];
  studentSet?: Maybe<StudentSet>;
  type: RequirementNodeType;
};

export type Requirement = {
  __typename?: 'Requirement';
  academicYear: MarblesAcademicYear;
  courseOfferings: Array<MarblesCourseOffering>;
  department: MarblesDepartment;
  departmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rulesInRequirement: Array<RuleInRequirement>;
  topics: Array<Topic>;
};

export enum RequirementBlockedReason {
  NoActiveEnrolment = 'NO_ACTIVE_ENROLMENT',
  NoSelfRegistration = 'NO_SELF_REGISTRATION',
  Other = 'OTHER',
}

export type RequirementGroup = {
  __typename?: 'RequirementGroup';
  applies: Scalars['Boolean']['output'];
  descriptions: Array<BilingualString>;
  name?: Maybe<Scalars['String']['output']>;
  rows: Array<RequirementRow>;
};

export type RequirementNode = {
  description: BilingualString;
  id: Scalars['String']['output'];
  type: RequirementNodeType;
};

export enum RequirementNodeType {
  Info = 'INFO',
  Logical = 'LOGICAL',
  RequiredCareer = 'REQUIRED_CAREER',
  RequiredCourses = 'REQUIRED_COURSES',
  RequiredPlan = 'REQUIRED_PLAN',
  RequiredStudentSet = 'REQUIRED_STUDENT_SET',
  Requirement = 'REQUIREMENT',
  Rule = 'RULE',
}

export type RequirementRow = {
  __typename?: 'RequirementRow';
  details: Array<RequirementRowDetail>;
  progress?: Maybe<BilingualString>;
  status: RequirementStatus;
  title?: Maybe<BilingualString>;
};

export type RequirementRowDetail = {
  __typename?: 'RequirementRowDetail';
  courseId?: Maybe<Scalars['String']['output']>;
  courseInfo?: Maybe<MarblesCourseInfo>;
  status: RequirementStatus;
};

export enum RequirementStatus {
  Fail = 'FAIL',
  Info = 'INFO',
  Pass = 'PASS',
}

export type Requirements = {
  __typename?: 'Requirements';
  block: Scalars['Boolean']['output'];
  groups: Array<RequirementGroup>;
};

export type ResetCreditLimitExceptionsPayload = {
  __typename?: 'ResetCreditLimitExceptionsPayload';
  mutationStatus: MutationStatus;
  studentIds: Array<Scalars['String']['output']>;
};

export type ResourceReference = {
  __typename?: 'ResourceReference';
  resourceId: Scalars['String']['output'];
  resourcePath: Scalars['String']['output'];
};

export enum ResourceType {
  Course = 'COURSE',
  CourseOffering = 'COURSE_OFFERING',
  EducationalInstitute = 'EDUCATIONAL_INSTITUTE',
  Faculty = 'FACULTY',
  Programme = 'PROGRAMME',
  StudentGroup = 'STUDENT_GROUP',
  University = 'UNIVERSITY',
}

export type RevokeAuthorisationInput = {
  id: Scalars['Int']['input'];
};

export type RevokeAuthorisationPayload = {
  __typename?: 'RevokeAuthorisationPayload';
  mutationStatus: MutationStatus;
};

export type RoleAssignment = {
  __typename?: 'RoleAssignment';
  createdBy: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  department: Department;
  id: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  userRole: UserRole;
};

export type Row = {
  __typename?: 'Row';
  coursePursuitId?: Maybe<Scalars['String']['output']>;
  line: Scalars['Int']['output'];
  rowStatus: MutationStatus;
  studentNumber: Scalars['String']['output'];
  topicName?: Maybe<Scalars['String']['output']>;
};

export type Rule = {
  __typename?: 'Rule';
  academicYear: MarblesAcademicYear;
  department: MarblesDepartment;
  departmentId: Scalars['String']['output'];
  descriptions: Array<BilingualString>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nodes: RuleNodes;
  requirements: Array<RuleRequirementSummary>;
  ruleKind: RuleKind;
};

export type RuleInRequirement = {
  __typename?: 'RuleInRequirement';
  allocationRound: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  includeInRetry: Scalars['Boolean']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  priorityLimit?: Maybe<Scalars['Int']['output']>;
  rule: Rule;
  ruleId: Scalars['String']['output'];
};

export type RuleInRequirementInput = {
  includeInRetry: Scalars['Boolean']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  priorityLimit?: InputMaybe<Scalars['Int']['input']>;
  ruleId: Scalars['String']['input'];
};

export enum RuleKind {
  Legacy = 'LEGACY',
  RequiredCareer = 'REQUIRED_CAREER',
  RequiredPlan = 'REQUIRED_PLAN',
  RequiredStudentSet = 'REQUIRED_STUDENT_SET',
}

export type RuleNodes = {
  __typename?: 'RuleNodes';
  groupRequirements: Array<GroupRequirementNode>;
  requirements: Array<RequirementNode>;
};

export type RuleRequirementSummary = {
  __typename?: 'RuleRequirementSummary';
  department: MarblesDepartment;
  departmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SelectCourseForRegistrationInput = {
  courseOfferingId: Scalars['String']['input'];
  coursePursuitId: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['String']['input']>;
};

export type SelectCourseForRegistrationPayload = {
  __typename?: 'SelectCourseForRegistrationPayload';
  blockReason?: Maybe<RequirementBlockedReason>;
  constrainedChoiceClusterSetting?: Maybe<ConstrainedChoiceClusterSetting>;
  courseOfferingId: Scalars['String']['output'];
  coursePursuitId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
  reason?: Maybe<BilingualString>;
  topicId?: Maybe<Scalars['String']['output']>;
};

export type Semester = {
  __typename?: 'Semester';
  academicYear: MarblesAcademicYear;
  id: Scalars['String']['output'];
  isCurrent: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  periods: Array<Period>;
};

export type SemesterTransitionMutationInput = {
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dryRun: Scalars['Boolean']['input'];
  facultyId?: InputMaybe<Scalars['String']['input']>;
  migrateConstrainedChoiceConfig: Scalars['Boolean']['input'];
  migrateOfferingCreditLimitException: Scalars['Boolean']['input'];
  migrateOfferingStatus: Scalars['Boolean']['input'];
  migrateOfferingSwapEnabled: Scalars['Boolean']['input'];
  migrateRequirementConfig: Scalars['Boolean']['input'];
  migrateTopicConfig: Scalars['Boolean']['input'];
  offeringIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceAcademicYear: Scalars['Int']['input'];
  targetSemesterId: Scalars['String']['input'];
};

export type SemesterTransitionMutationPayload = {
  __typename?: 'SemesterTransitionMutationPayload';
  issues: Array<MigrationIssue>;
  status: MutationStatus;
};

export type SendMailInput = {
  content: Scalars['String']['input'];
  recipient: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SendMailOutput = {
  __typename?: 'SendMailOutput';
  mutationStatus: MutationStatus;
};

export type SetCourseOfferingConstrainedChoiceClusterInput = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  courseOfferingId: Scalars['String']['input'];
};

export type SetCourseOfferingConstrainedChoiceClusterPayload = {
  __typename?: 'SetCourseOfferingConstrainedChoiceClusterPayload';
  clusterId?: Maybe<Scalars['String']['output']>;
  courseOffering?: Maybe<MarblesCourseOffering>;
  mutationStatus: MutationStatus;
};

export type SetCourseOfferingCreditLimitExceptionInput = {
  courseOfferingId: Scalars['String']['input'];
  hasCreditLimitException: Scalars['Boolean']['input'];
};

export type SetCourseOfferingCreditLimitExceptionPayload = {
  __typename?: 'SetCourseOfferingCreditLimitExceptionPayload';
  courseOfferingId: Scalars['String']['output'];
  hasCreditLimitException: Scalars['Boolean']['output'];
  mutationStatus: MutationStatus;
};

export type SetCourseOfferingRequirementNodeInput = {
  courseOfferingId: Scalars['String']['input'];
  requirementNodeId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCourseOfferingRequirementNodePayload = {
  __typename?: 'SetCourseOfferingRequirementNodePayload';
  courseOfferingId: Scalars['String']['output'];
  courseOfferingRequirementCapacities?: Maybe<Array<CourseOfferingRequirementCapacity>>;
  mutationStatus: MutationStatus;
  requirementNodeId?: Maybe<Scalars['String']['output']>;
};

export type SetCourseOfferingStatusInput = {
  courseOfferingId: Scalars['String']['input'];
  status: MarblesCourseOfferingStatus;
};

export type SetCourseOfferingStatusPayload = {
  __typename?: 'SetCourseOfferingStatusPayload';
  courseOfferingId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
  status: MarblesCourseOfferingStatus;
};

export type SetCourseOfferingTopicSetInput = {
  courseOfferingId: Scalars['String']['input'];
  topicSetId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCourseOfferingTopicSetPayload = {
  __typename?: 'SetCourseOfferingTopicSetPayload';
  courseOfferingId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
  topicSet?: Maybe<TopicSet>;
};

export type SetCoursePursuitTopicInput = {
  pursuitId: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['String']['input']>;
};

export type SetCoursePursuitTopicPayload = {
  __typename?: 'SetCoursePursuitTopicPayload';
  coursePursuitId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
  topicId?: Maybe<Scalars['String']['output']>;
};

export type SetCreditLimitExceptionInput = {
  hasCreditLimitException: Scalars['Boolean']['input'];
  studentId: Scalars['String']['input'];
};

export type SetCreditLimitExceptionPayload = {
  __typename?: 'SetCreditLimitExceptionPayload';
  hasCreditLimitException: Scalars['Boolean']['output'];
  mutationStatus: MutationStatus;
  studentId: Scalars['String']['output'];
};

export type SetGroupSwapEnabledInput = {
  courseOfferingId: Scalars['String']['input'];
  groupSwapEnabled: Scalars['Boolean']['input'];
};

export type SetGroupSwapEnabledPayload = {
  __typename?: 'SetGroupSwapEnabledPayload';
  courseOfferingId: Scalars['String']['output'];
  groupSwapEnabled: Scalars['Boolean']['output'];
  mutationStatus: MutationStatus;
};

export type SetNonAdminsToReadOnlyInput = {
  readOnly: Scalars['Boolean']['input'];
};

export type SetNonAdminsToReadOnlyPayload = {
  __typename?: 'SetNonAdminsToReadOnlyPayload';
  mutationStatus: MutationStatus;
};

export type SetStudentGroupCapacityInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  studentGroupId: Scalars['String']['input'];
};

export type SetStudentGroupCapacityPayload = {
  __typename?: 'SetStudentGroupCapacityPayload';
  configuredCapacity?: Maybe<Scalars['Int']['output']>;
  mutationStatus: MutationStatus;
  studentGroupId: Scalars['String']['output'];
};

export type SetStudentGroupTopicInput = {
  studentGroupId: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['String']['input']>;
};

export type SetStudentGroupTopicPayload = {
  __typename?: 'SetStudentGroupTopicPayload';
  mutationStatus: MutationStatus;
  studentGroupId?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Topic>;
  topicId?: Maybe<Scalars['String']['output']>;
};

export type SetStudentTimetablePreferencesInput = {
  avoidTimeSlots: Array<TimeSlot>;
  distribution: TimetableDistributionPreference;
  studentNumber: Scalars['String']['input'];
};

export type SetStudentTimetablePreferencesPayload = {
  __typename?: 'SetStudentTimetablePreferencesPayload';
  avoidTimeSlots: Array<TimeSlot>;
  distribution: TimetableDistributionPreference;
  mutationStatus: MutationStatus;
};

export type SetTimetablePreferencesInput = {
  avoidTimeSlots: Array<TimeSlot>;
  distribution: TimetableDistributionPreference;
};

export type SetTimetablePreferencesPayload = {
  __typename?: 'SetTimetablePreferencesPayload';
  avoidTimeSlots: Array<TimeSlot>;
  distribution: TimetableDistributionPreference;
  mutationStatus: MutationStatus;
};

export enum StaffDeregistrationReason {
  Administrative = 'ADMINISTRATIVE',
  CourseCancelled = 'COURSE_CANCELLED',
  StudentExceedsCreditLimit = 'STUDENT_EXCEEDS_CREDIT_LIMIT',
  StudentFailedRequirements = 'STUDENT_FAILED_REQUIREMENTS',
  StudentQuitsProgramme = 'STUDENT_QUITS_PROGRAMME',
  StudentRequestedDeregistration = 'STUDENT_REQUESTED_DEREGISTRATION',
}

export type Student = {
  __typename?: 'Student';
  email: Scalars['String']['output'];
  enrolments: Array<Enrolment>;
  givenName: Scalars['String']['output'];
  hasCreditLimitException: Scalars['Boolean']['output'];
  hasTimetablePreferences: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  studentNumber: Scalars['String']['output'];
  surname: Scalars['String']['output'];
  surnamePrefix: Scalars['String']['output'];
};

export type StudentEnrolmentsArgs = {
  academicYear?: InputMaybe<Scalars['Int']['input']>;
};

export type StudentCourse = {
  __typename?: 'StudentCourse';
  courseId: Scalars['String']['output'];
  info: MarblesCourseInfo;
};

export type StudentGroup = {
  __typename?: 'StudentGroup';
  /** admin */
  capacity: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  /** admin */
  configuredCapacity?: Maybe<Scalars['Int']['output']>;
  /** admin */
  courseOffering: MarblesCourseOffering;
  courseOfferingId: Scalars['String']['output'];
  /** admin */
  directRegistrationEnabled: Scalars['Boolean']['output'];
  /** admin */
  groupSwapDemand: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  /** admin */
  initialCapacity: Scalars['Int']['output'];
  lecturers: Array<CourseOfferingLecturer>;
  /** admin */
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** admin */
  numberOfRegisteredStudents: Scalars['Int']['output'];
  /** admin */
  timetableSummary: BilingualString;
  topic?: Maybe<Topic>;
};

export type StudentRequirementsCheckPayload = {
  __typename?: 'StudentRequirementsCheckPayload';
  requirementsCheck: Requirements;
  student: Student;
};

export type StudentSearchResult = {
  __typename?: 'StudentSearchResult';
  searchResults: Array<Student>;
  totalCount: Scalars['Int']['output'];
};

export type StudentSet = {
  __typename?: 'StudentSet';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  title: BilingualString;
};

export type SubmitCourseDescriptionsDraftPayload = {
  __typename?: 'SubmitCourseDescriptionsDraftPayload';
  course?: Maybe<Course>;
  mutationStatus: MutationStatus;
};

export type SubmitCourseDescriptionsInput = {
  academicYear: Scalars['Int']['input'];
  courseId: Scalars['String']['input'];
};

export type SubmitCourseDraftInput = {
  academicYear: Scalars['Int']['input'];
  courseId: Scalars['String']['input'];
};

export type SubmitCourseDraftPayload = {
  __typename?: 'SubmitCourseDraftPayload';
  course?: Maybe<Course>;
  mutationStatus: MutationStatus;
};

export type SubmitTimetableConstraintsDraftInput = {
  courseOfferingId: Scalars['String']['input'];
  timetableConstraintsInput: TimetableConstraintsInput;
};

export type SubmitTimetableConstraintsDraftPayload = {
  __typename?: 'SubmitTimetableConstraintsDraftPayload';
  mutationStatus: MutationStatus;
  timetableConstraints?: Maybe<TimetableConstraints>;
};

export type Subplan = {
  __typename?: 'Subplan';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type SwappableStudentGroup = {
  __typename?: 'SwappableStudentGroup';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  timetableSummary: BilingualString;
};

export type SwitchStudentGroupInput = {
  coursePursuitId: Scalars['String']['input'];
  studentGroupId: Scalars['String']['input'];
};

export type SwitchStudentGroupPayload = {
  __typename?: 'SwitchStudentGroupPayload';
  coursePursuitId: Scalars['String']['output'];
  mutationStatus: MutationStatus;
  reason?: Maybe<Scalars['String']['output']>;
  studentGroupId: Scalars['String']['output'];
};

export type SyncResourcesPayload = {
  __typename?: 'SyncResourcesPayload';
  syncResults: Array<SyncResult>;
};

export type SyncResourcesToMagnifierInput = {
  dryRun: Scalars['Boolean']['input'];
  resourceTypes: Array<ResourceType>;
};

export type SyncResult = {
  __typename?: 'SyncResult';
  mutationStatus: MutationStatus;
  resourceType: ResourceType;
  resourcesAdded: Array<ResourceReference>;
  resourcesRemoved: Array<ResourceReference>;
  resourcesUpdated: Array<ResourceReference>;
};

export enum TimeSlot {
  FridayAfternoon = 'FRIDAY_AFTERNOON',
  FridayEvening = 'FRIDAY_EVENING',
  FridayMorning = 'FRIDAY_MORNING',
  MondayAfternoon = 'MONDAY_AFTERNOON',
  MondayEvening = 'MONDAY_EVENING',
  MondayMorning = 'MONDAY_MORNING',
  ThursdayAfternoon = 'THURSDAY_AFTERNOON',
  ThursdayEvening = 'THURSDAY_EVENING',
  ThursdayMorning = 'THURSDAY_MORNING',
  TuesdayAfternoon = 'TUESDAY_AFTERNOON',
  TuesdayEvening = 'TUESDAY_EVENING',
  TuesdayMorning = 'TUESDAY_MORNING',
  WednesdayAfternoon = 'WEDNESDAY_AFTERNOON',
  WednesdayEvening = 'WEDNESDAY_EVENING',
  WednesdayMorning = 'WEDNESDAY_MORNING',
}

export type TimeTravelToPayload = {
  __typename?: 'TimeTravelToPayload';
  offset: Scalars['Long']['output'];
  registrationRounds: Array<RegistrationRound>;
};

export type TimetableActivity = {
  __typename?: 'TimetableActivity';
  dayOfWeek: DayOfWeek;
  description: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPublishedForStudents: Scalars['Boolean']['output'];
  locations: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  studentGroups: Array<StudentGroup>;
  type: Scalars['String']['output'];
  weeks: Array<Scalars['Int']['output']>;
};

export type TimetableAssessmentConfiguration = {
  __typename?: 'TimetableAssessmentConfiguration';
  assessmentInAns: Scalars['Boolean']['output'];
  expectedAssessmentPercentage: Scalars['Int']['output'];
  inspectionType: TimetableConstraintAssessmentInspectionType;
  inspectionWeeksPostAssessment: Scalars['Int']['output'];
  laptopCompatibility?: Maybe<TimetableConstraintLaptopCompatibility>;
  type: TimetableConstraintAssessmentType;
};

export type TimetableConstraintActivity = {
  __typename?: 'TimetableConstraintActivity';
  assessmentConfiguration?: Maybe<TimetableAssessmentConfiguration>;
  durationMinutes: Scalars['Int']['output'];
  groupCount: Scalars['Int']['output'];
  lecturers: Array<User>;
  maxParallelGroups: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  period: Scalars['Int']['output'];
  roomRequired: Scalars['Boolean']['output'];
  studentNotes?: Maybe<Scalars['String']['output']>;
  timetableNotes?: Maybe<Scalars['String']['output']>;
  type: TimetableConstraintActivityType;
  weekPattern: Array<Scalars['Int']['output']>;
};

export enum TimetableConstraintActivityType {
  Assessment = 'ASSESSMENT',
  ClinicalLecture = 'CLINICAL_LECTURE',
  ComputerLab = 'COMPUTER_LAB',
  Excursion = 'EXCURSION',
  Fieldwork = 'FIELDWORK',
  Lecture = 'LECTURE',
  Other = 'OTHER',
  Practical = 'PRACTICAL',
  Qa = 'QA',
  Seminar = 'SEMINAR',
  Session = 'SESSION',
  Tutorial = 'TUTORIAL',
  Tutoring = 'TUTORING',
}

export enum TimetableConstraintAssessmentInspectionType {
  Digital = 'DIGITAL',
  InPerson = 'IN_PERSON',
  None = 'NONE',
}

export enum TimetableConstraintAssessmentType {
  Digital = 'DIGITAL',
  Presentation = 'PRESENTATION',
  Written = 'WRITTEN',
}

export enum TimetableConstraintLaptopCompatibility {
  Broad = 'BROAD',
  Limited = 'LIMITED',
}

export type TimetableConstraints = {
  __typename?: 'TimetableConstraints';
  activities: Array<TimetableConstraintActivity>;
  activityIntervalNotes?: Maybe<Scalars['String']['output']>;
  assessmentNotes?: Maybe<Scalars['String']['output']>;
  courseOfferingId: Scalars['String']['output'];
  expectedResitPercentage: Scalars['Int']['output'];
  expectedStudentCount: Scalars['Int']['output'];
  facilitiesNotes?: Maybe<Scalars['String']['output']>;
  generalNotes?: Maybe<Scalars['String']['output']>;
  lecturerNotes?: Maybe<Scalars['String']['output']>;
  lecturers: Array<User>;
  roomRecordingCapabilityRequired: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
  validationStatus: ValidationDetails;
};

export type TimetableConstraintsInput = {
  activities: Array<TimetableConstraintsInputActivityInput>;
  activityIntervalNotes?: InputMaybe<Scalars['String']['input']>;
  assessmentNotes?: InputMaybe<Scalars['String']['input']>;
  expectedResitPercentage: Scalars['Int']['input'];
  expectedStudentCount: Scalars['Int']['input'];
  facilitiesNotes?: InputMaybe<Scalars['String']['input']>;
  generalNotes?: InputMaybe<Scalars['String']['input']>;
  lecturerIds: Array<Scalars['String']['input']>;
  lecturerNotes?: InputMaybe<Scalars['String']['input']>;
  roomRecordingCapabilityRequired: Scalars['Boolean']['input'];
};

export type TimetableConstraintsInputActivityInput = {
  assessmentConfiguration?: InputMaybe<TimetableConstraintsInputAssessmentConfigurationInput>;
  durationMinutes: Scalars['Int']['input'];
  groupCount: Scalars['Int']['input'];
  lecturerIds: Array<Scalars['String']['input']>;
  maxParallelGroups: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  period: Scalars['Int']['input'];
  roomRequired: Scalars['Boolean']['input'];
  studentNotes?: InputMaybe<Scalars['String']['input']>;
  timetableNotes?: InputMaybe<Scalars['String']['input']>;
  type: TimetableConstraintActivityType;
  weekPattern: Array<Scalars['Int']['input']>;
};

export type TimetableConstraintsInputAssessmentConfigurationInput = {
  assessmentInAns: Scalars['Boolean']['input'];
  expectedAssessmentPercentage: Scalars['Int']['input'];
  inspectionType: TimetableConstraintAssessmentInspectionType;
  inspectionWeeksPostAssessment: Scalars['Int']['input'];
  laptopCompatibility?: InputMaybe<TimetableConstraintLaptopCompatibility>;
  type: TimetableConstraintAssessmentType;
};

export enum TimetableDistributionPreference {
  Cluster = 'CLUSTER',
  None = 'NONE',
  Spread = 'SPREAD',
}

export enum TimetableLocation {
  Amc = 'AMC',
  None = 'NONE',
  Other = 'OTHER',
  RoeterseilandCampus = 'ROETERSEILAND_CAMPUS',
  SciencePark = 'SCIENCE_PARK',
  Universiteitskwartier = 'UNIVERSITEITSKWARTIER',
  VrijeUniversiteitAmsterdam = 'VRIJE_UNIVERSITEIT_AMSTERDAM',
}

export type TimetablePreferences = {
  __typename?: 'TimetablePreferences';
  avoidTimeSlots: Array<TimeSlot>;
  distribution: TimetableDistributionPreference;
};

export type Topic = {
  __typename?: 'Topic';
  id: Scalars['String']['output'];
  requirement?: Maybe<Requirement>;
  title: BilingualString;
  topicSet: TopicSet;
  topicSetId: Scalars['String']['output'];
};

export type TopicCapacity = {
  __typename?: 'TopicCapacity';
  available: Scalars['Int']['output'];
  topicId: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type TopicSet = {
  __typename?: 'TopicSet';
  academicYear: MarblesAcademicYear;
  courseOfferings: Array<MarblesCourseOffering>;
  department: MarblesDepartment;
  departmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** admin */
  name: Scalars['String']['output'];
  title: BilingualString;
  topics: Array<Topic>;
};

export type UnlockStudentGroupInput = {
  studentGroupId: Scalars['String']['input'];
};

export type UnlockStudentGroupPayload = {
  __typename?: 'UnlockStudentGroupPayload';
  mutationStatus: MutationStatus;
  studentGroupId: Scalars['String']['output'];
};

export type UpdateConstrainedChoiceClusterMutationInput = {
  constrainedChoiceClusterId: Scalars['String']['input'];
  registrationLimit: Scalars['Int']['input'];
  titleEN: Scalars['String']['input'];
  titleNL: Scalars['String']['input'];
};

export type UpdateConstrainedChoiceClusterMutationPayload = {
  __typename?: 'UpdateConstrainedChoiceClusterMutationPayload';
  constrainedChoiceCluster?: Maybe<ConstrainedChoiceCluster>;
  mutationStatus: MutationStatus;
};

export type UpdateConstrainedChoiceSettingInput = {
  pursuitIds: Array<Scalars['String']['input']>;
  registrationLimit: Scalars['Int']['input'];
  settingsId: Scalars['String']['input'];
};

export type UpdateConstrainedChoiceSettingPayload = {
  __typename?: 'UpdateConstrainedChoiceSettingPayload';
  mutationStatus: MutationStatus;
  setting?: Maybe<ConstrainedChoiceClusterSetting>;
  settingsId: Scalars['String']['output'];
};

export type UpdateCourseCatalogDescriptionsInput = {
  academicYear: Scalars['Int']['input'];
  courseId: Scalars['String']['input'];
  descriptions: CourseCatalogDescriptionsInput;
};

export type UpdateCourseCatalogDescriptionsPayload = {
  __typename?: 'UpdateCourseCatalogDescriptionsPayload';
  course?: Maybe<Course>;
  mutationStatus: MutationStatus;
};

export type UpdateCourseInput = {
  academicYear: Scalars['Int']['input'];
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  credits: Scalars['Float']['input'];
  gradingScheme?: InputMaybe<GradingScheme>;
  id: Scalars['String']['input'];
  nameEN: Scalars['String']['input'];
  nameNL: Scalars['String']['input'];
  type: CourseType;
};

export type UpdateCourseOfferingLecturersInput = {
  courseOfferingId: Scalars['String']['input'];
  lecturers: Array<UpdateCourseOfferingLecturersInputLecturersInput>;
};

export type UpdateCourseOfferingLecturersInputLecturersInput = {
  displayInCourseCatalog: Scalars['Boolean']['input'];
  studentGroups: Array<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type UpdateCourseOfferingLecturersPayload = {
  __typename?: 'UpdateCourseOfferingLecturersPayload';
  courseOfferingId?: Maybe<Scalars['String']['output']>;
  lecturers?: Maybe<Array<CourseOfferingLecturer>>;
  mutationStatus: MutationStatus;
};

export type UpdateCourseOfferingsInput = {
  academicYear: Scalars['Int']['input'];
  courseId: Scalars['String']['input'];
  offerings: Array<UpdateCourseOfferingsInputOfferingInput>;
};

export type UpdateCourseOfferingsInputOfferingInput = {
  coordinator?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instructionLanguage: Language;
  periods: Array<Scalars['Int']['input']>;
};

export type UpdateCourseOfferingsPayload = {
  __typename?: 'UpdateCourseOfferingsPayload';
  mutationStatus: MutationStatus;
  nextOfferingNumber?: Maybe<Scalars['Int']['output']>;
  offerings?: Maybe<Array<CourseOffering>>;
};

export type UpdateCoursePayload = {
  __typename?: 'UpdateCoursePayload';
  course?: Maybe<Course>;
  mutationStatus: MutationStatus;
};

export type UpdateCourseSettingsInput = {
  academicYear: Scalars['Int']['input'];
  ansEnabled: Scalars['Boolean']['input'];
  courseCatalogEnabled: Scalars['Boolean']['input'];
  courseCatalogIsOpenUvACourse: Scalars['Boolean']['input'];
  courseId: Scalars['String']['input'];
  courseRegistrationEnabled: Scalars['Boolean']['input'];
  craAllowIncompleteGradeLists: Scalars['Boolean']['input'];
  craEnabled: Scalars['Boolean']['input'];
  lmsCopyContentsFromPreviousYear: Scalars['Boolean']['input'];
  lmsEnablePrivacySection: Scalars['Boolean']['input'];
  lmsEnabled: Scalars['Boolean']['input'];
  sisOfferingIdsAvailableForExchangeStudents: Array<Scalars['String']['input']>;
  timetableConstraintsEnabled: Scalars['Boolean']['input'];
  timetableEnabled: Scalars['Boolean']['input'];
  timetableLocation: TimetableLocation;
};

export type UpdateCourseSettingsPayload = {
  __typename?: 'UpdateCourseSettingsPayload';
  courseSettings?: Maybe<CourseSettings>;
  mutationStatus: MutationStatus;
};

export type UpdateInfoRequirementMutationInput = {
  description: BilingualStringInput;
  nodeId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
};

export type UpdateInfoRequirementMutationPayload = {
  __typename?: 'UpdateInfoRequirementMutationPayload';
  mutationStatus: MutationStatus;
  nodeId: Scalars['String']['output'];
  rule?: Maybe<Rule>;
  ruleId: Scalars['String']['output'];
};

export type UpdateRequiredCareerMutationInput = {
  careerIds: Array<Scalars['String']['input']>;
  nodeId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
};

export type UpdateRequiredCareerMutationPayload = {
  __typename?: 'UpdateRequiredCareerMutationPayload';
  mutationStatus: MutationStatus;
  nodeId: Scalars['String']['output'];
  rule?: Maybe<Rule>;
  ruleId: Scalars['String']['output'];
};

export type UpdateRequiredCoursesMutationInput = {
  courses: RequiredCoursesInput;
  description: BilingualStringInput;
  nodeId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
};

export type UpdateRequiredCoursesMutationPayload = {
  __typename?: 'UpdateRequiredCoursesMutationPayload';
  mutationStatus: MutationStatus;
  nodeId: Scalars['String']['output'];
  rule?: Maybe<Rule>;
  ruleId: Scalars['String']['output'];
};

export type UpdateRequiredPlanMutationInput = {
  nodeId: Scalars['String']['input'];
  plan: RequiredPlanInput;
  ruleId: Scalars['String']['input'];
};

export type UpdateRequiredPlanMutationPayload = {
  __typename?: 'UpdateRequiredPlanMutationPayload';
  mutationStatus: MutationStatus;
  nodeId: Scalars['String']['output'];
  rule?: Maybe<Rule>;
  ruleId: Scalars['String']['output'];
};

export type UpdateRequiredStudentSetMutationInput = {
  nodeId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
  studentSetId: Scalars['String']['input'];
};

export type UpdateRequiredStudentSetMutationPayload = {
  __typename?: 'UpdateRequiredStudentSetMutationPayload';
  mutationStatus: MutationStatus;
  nodeId: Scalars['String']['output'];
  rule?: Maybe<Rule>;
  ruleId: Scalars['String']['output'];
};

export type UpdateRequirementNameMutationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  requirementId: Scalars['String']['input'];
};

export type UpdateRequirementNameMutationPayload = {
  __typename?: 'UpdateRequirementNameMutationPayload';
  mutationStatus: MutationStatus;
  requirement?: Maybe<Requirement>;
};

export type UpdateRequirementRulesMutationInput = {
  requirementId: Scalars['String']['input'];
  rules: Array<RuleInRequirementInput>;
};

export type UpdateRequirementRulesMutationPayload = {
  __typename?: 'UpdateRequirementRulesMutationPayload';
  mutationStatus: MutationStatus;
  requirement?: Maybe<Requirement>;
};

export type UpdateRuleNameMutationInput = {
  name: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
};

export type UpdateRuleNameMutationPayload = {
  __typename?: 'UpdateRuleNameMutationPayload';
  mutationStatus: MutationStatus;
  rule?: Maybe<Rule>;
};

export type UpdateStudentGroupsInput = {
  courseOfferingId: Scalars['String']['input'];
  studentGroups: Array<UpdateStudentGroupsInputGroupsInput>;
};

export type UpdateStudentGroupsInputGroupsInput = {
  capacity: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lecturers?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type UpdateStudentGroupsPayload = {
  __typename?: 'UpdateStudentGroupsPayload';
  courseOfferingId?: Maybe<Scalars['String']['output']>;
  mutationStatus: MutationStatus;
  studentGroups?: Maybe<Array<StudentGroup>>;
};

export type UpdateTimetableConstraintsInput = {
  activities: Array<TimetableConstraintsInputActivityInput>;
  activityIntervalNotes?: InputMaybe<Scalars['String']['input']>;
  assessmentNotes?: InputMaybe<Scalars['String']['input']>;
  courseOfferingId: Scalars['String']['input'];
  expectedResitPercentage: Scalars['Int']['input'];
  expectedStudentCount: Scalars['Int']['input'];
  facilitiesNotes?: InputMaybe<Scalars['String']['input']>;
  generalNotes?: InputMaybe<Scalars['String']['input']>;
  lecturerIds: Array<Scalars['String']['input']>;
  lecturerNotes?: InputMaybe<Scalars['String']['input']>;
  roomRecordingCapabilityRequired: Scalars['Boolean']['input'];
};

export type UpdateTimetableConstraintsPayload = {
  __typename?: 'UpdateTimetableConstraintsPayload';
  mutationStatus: MutationStatus;
  timetableConstraints?: Maybe<TimetableConstraints>;
};

export type UpdateTopicMutationInput = {
  requirementNodeId?: InputMaybe<Scalars['String']['input']>;
  titleEN: Scalars['String']['input'];
  titleNL: Scalars['String']['input'];
  topicId: Scalars['String']['input'];
};

export type UpdateTopicMutationPayload = {
  __typename?: 'UpdateTopicMutationPayload';
  mutationStatus: MutationStatus;
  topic?: Maybe<Topic>;
};

export type UpdateTopicSetNameMutationInput = {
  name: Scalars['String']['input'];
  titleEN: Scalars['String']['input'];
  titleNL: Scalars['String']['input'];
  topicSetId: Scalars['String']['input'];
};

export type UpdateTopicSetNameMutationPayload = {
  __typename?: 'UpdateTopicSetNameMutationPayload';
  mutationStatus: MutationStatus;
  topicSet?: Maybe<TopicSet>;
};

export type UploadBulkCourseDeregistrationsInput = {
  academicYear: Scalars['Int']['input'];
  deregistrationReason: StaffDeregistrationReason;
  file: Scalars['Upload']['input'];
  ignorePursuitsNotFound: Scalars['Boolean']['input'];
};

export type UploadBulkCourseDeregistrationsPayload = {
  __typename?: 'UploadBulkCourseDeregistrationsPayload';
  details?: Maybe<Array<Scalars['String']['output']>>;
  missingColumns?: Maybe<Array<MissingColumn>>;
  mutationStatus: MutationStatus;
  pursuits: Array<CoursePursuit>;
  result: Array<UploadCourseDeregistrationsPayloadResultRow>;
};

export type UploadBulkCourseRegistrationsInput = {
  academicYear: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  skipRequirements: Scalars['Boolean']['input'];
  switchGroupIfAlreadyRegistered: Scalars['Boolean']['input'];
};

export type UploadBulkCourseRegistrationsPayload = {
  __typename?: 'UploadBulkCourseRegistrationsPayload';
  details?: Maybe<Array<Scalars['String']['output']>>;
  missingColumns?: Maybe<Array<MissingColumn>>;
  mutationStatus: MutationStatus;
  pursuits: Array<CoursePursuit>;
  result: Array<UploadCourseRegistrationsPayloadResultRow>;
};

export type UploadCourseDeregistrationsInput = {
  courseOfferingId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  reason?: InputMaybe<StaffDeregistrationReason>;
};

export type UploadCourseDeregistrationsPayload = {
  __typename?: 'UploadCourseDeregistrationsPayload';
  courseOfferingId: Scalars['String']['output'];
  missingColumns?: Maybe<Array<MissingColumn>>;
  mutationStatus: MutationStatus;
  result: Array<UploadCourseDeregistrationsPayloadResultRow>;
};

export type UploadCourseDeregistrationsPayloadResultRow = {
  __typename?: 'UploadCourseDeregistrationsPayloadResultRow';
  line: Scalars['Int']['output'];
  rowStatus: MutationStatus;
  studentNumber: Scalars['String']['output'];
};

export type UploadCoursePendingStudentsInput = {
  courseOfferingId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  skipRequirements?: Scalars['Boolean']['input'];
  switchTopicIfAlreadyPending: Scalars['Boolean']['input'];
};

export type UploadCoursePendingStudentsPayload = {
  __typename?: 'UploadCoursePendingStudentsPayload';
  courseOfferingId: Scalars['String']['output'];
  missingColumns?: Maybe<Array<MissingColumn>>;
  mutationStatus: MutationStatus;
  pursuits: Array<CoursePursuit>;
  result: Array<Row>;
};

export type UploadCourseRegistrationsInput = {
  courseOfferingId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  skipRequirements: Scalars['Boolean']['input'];
  switchGroupIfAlreadyRegistered: Scalars['Boolean']['input'];
};

export type UploadCourseRegistrationsPayload = {
  __typename?: 'UploadCourseRegistrationsPayload';
  courseOfferingId: Scalars['String']['output'];
  missingColumns?: Maybe<Array<MissingColumn>>;
  mutationStatus: MutationStatus;
  pursuits: Array<CoursePursuit>;
  result: Array<UploadCourseRegistrationsPayloadResultRow>;
};

export type UploadCourseRegistrationsPayloadResultRow = {
  __typename?: 'UploadCourseRegistrationsPayloadResultRow';
  courseOfferingId: Scalars['String']['output'];
  groupCode: Scalars['String']['output'];
  line: Scalars['Int']['output'];
  rowStatus: MutationStatus;
  studentNumber: Scalars['String']['output'];
};

export type UploadCreditLimitExceptionsInput = {
  file: Scalars['Upload']['input'];
};

export type UploadCreditLimitExceptionsPayload = {
  __typename?: 'UploadCreditLimitExceptionsPayload';
  missingColumns?: Maybe<Array<MissingColumn>>;
  mutationStatus: MutationStatus;
  result: Array<UploadCreditLimitExceptionsPayloadResultRow>;
};

export type UploadCreditLimitExceptionsPayloadResultRow = {
  __typename?: 'UploadCreditLimitExceptionsPayloadResultRow';
  hasCreditLimitException: Scalars['Boolean']['output'];
  line: Scalars['Int']['output'];
  rowStatus: MutationStatus;
  studentNumber: Scalars['String']['output'];
};

export type UploadGroupSettingsInput = {
  courseOfferingId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};

export type UploadGroupSettingsPayload = {
  __typename?: 'UploadGroupSettingsPayload';
  missingColumns?: Maybe<Array<MissingColumn>>;
  mutationStatus: MutationStatus;
  result: Array<UploadGroupSettingsPayloadResultRow>;
};

export type UploadGroupSettingsPayloadResultRow = {
  __typename?: 'UploadGroupSettingsPayloadResultRow';
  groupCode: Scalars['String']['output'];
  line: Scalars['Int']['output'];
  rowStatus: MutationStatus;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  isAdminPanelUser: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleAssignments: Array<RoleAssignment>;
  status: UserStatus;
  studentId?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export enum UserAction {
  AdminAction = 'ADMIN_ACTION',
  EditActiveCourse = 'EDIT_ACTIVE_COURSE',
  EditActiveCourseCatalogDescriptions = 'EDIT_ACTIVE_COURSE_CATALOG_DESCRIPTIONS',
  EditAuthorisations = 'EDIT_AUTHORISATIONS',
  EditConstrainedChoiceClusters = 'EDIT_CONSTRAINED_CHOICE_CLUSTERS',
  EditCourseSettings = 'EDIT_COURSE_SETTINGS',
  EditDraftCourse = 'EDIT_DRAFT_COURSE',
  EditDraftCourseCatalogDescriptions = 'EDIT_DRAFT_COURSE_CATALOG_DESCRIPTIONS',
  EditDraftTimetableConstraints = 'EDIT_DRAFT_TIMETABLE_CONSTRAINTS',
  EditRegistrations = 'EDIT_REGISTRATIONS',
  EditRequirements = 'EDIT_REQUIREMENTS',
  EditStudents = 'EDIT_STUDENTS',
  EditSubmittedCourse = 'EDIT_SUBMITTED_COURSE',
  EditSubmittedCourseCatalogDescriptions = 'EDIT_SUBMITTED_COURSE_CATALOG_DESCRIPTIONS',
  EditSubmittedTimetableConstraints = 'EDIT_SUBMITTED_TIMETABLE_CONSTRAINTS',
  EditTopicSets = 'EDIT_TOPIC_SETS',
  ProcessGroupSwapRequests = 'PROCESS_GROUP_SWAP_REQUESTS',
  UploadCreditLimitExceptions = 'UPLOAD_CREDIT_LIMIT_EXCEPTIONS',
  View = 'VIEW',
}

export type UserProfile = {
  __typename?: 'UserProfile';
  allowedUserActions: Array<UserAction>;
  enabledModules: Array<ApplicationModule>;
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: UserStatus;
  student?: Maybe<Student>;
  studentId?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UserRole = {
  __typename?: 'UserRole';
  description: BilingualString;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum UserStatus {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED',
  SuspensionLifted = 'SUSPENSION_LIFTED',
}

export type ValidationAudit = {
  __typename?: 'ValidationAudit';
  reason?: Maybe<Scalars['String']['output']>;
  status: ValidationStatus;
  stepCount?: Maybe<Scalars['Int']['output']>;
  stepName?: Maybe<BilingualString>;
  stepNumber?: Maybe<Scalars['Int']['output']>;
  timestamp: Scalars['DateTime']['output'];
  user: User;
};

export type ValidationDetails = {
  __typename?: 'ValidationDetails';
  audit: Array<ValidationAudit>;
  canComplete: Scalars['Boolean']['output'];
  status: ValidationStatus;
  steps: Array<ValidationStep>;
};

export enum ValidationStage {
  Submission = 'SUBMISSION',
  Verification = 'VERIFICATION',
}

export enum ValidationStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  Verified = 'VERIFIED',
}

export type ValidationStep = {
  __typename?: 'ValidationStep';
  canComplete: Scalars['Boolean']['output'];
  completed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: BilingualString;
  stage: ValidationStage;
};

export type VerifyCourseDescriptionsSubmissionInput = {
  academicYear: Scalars['Int']['input'];
  courseId: Scalars['String']['input'];
  stepId: Scalars['String']['input'];
};

export type VerifyCourseDescriptionsSubmissionPayload = {
  __typename?: 'VerifyCourseDescriptionsSubmissionPayload';
  course?: Maybe<Course>;
  mutationStatus: MutationStatus;
};

export type VerifyCourseSubmissionInput = {
  academicYear: Scalars['Int']['input'];
  courseId: Scalars['String']['input'];
  stepId: Scalars['String']['input'];
};

export type VerifyCourseSubmissionPayload = {
  __typename?: 'VerifyCourseSubmissionPayload';
  course?: Maybe<Course>;
  mutationStatus: MutationStatus;
};

export type VerifyTimetableConstraintsSubmissionInput = {
  courseOfferingId: Scalars['String']['input'];
  stepId: Scalars['String']['input'];
  timetableConstraintsInput: TimetableConstraintsInput;
};

export type VerifyTimetableConstraintsSubmissionPayload = {
  __typename?: 'VerifyTimetableConstraintsSubmissionPayload';
  mutationStatus: MutationStatus;
  timetableConstraints?: Maybe<TimetableConstraints>;
};

export type AcademicYearFragment = {
  __typename?: 'AcademicYear';
  id: number;
  name: string;
  startDate: any;
  endDate: any;
  isCurrentAcademicYearForAdmins: boolean;
  isArchived: boolean;
};

export type DepartmentFragment = {
  __typename?: 'Department';
  id: string;
  code: string;
  allowedUserActions: Array<UserAction>;
  parentId?: string | null;
  name: { __typename?: 'BilingualString'; EN: string; NL: string };
};

export type GetDepartmentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetDepartmentsQuery = {
  __typename?: 'Query';
  departments: Array<{
    __typename?: 'Department';
    id: string;
    code: string;
    allowedUserActions: Array<UserAction>;
    parentId?: string | null;
    name: { __typename?: 'BilingualString'; EN: string; NL: string };
  }>;
};

export type GetMaintenanceMessagesQueryVariables = Exact<{ [key: string]: never }>;

export type GetMaintenanceMessagesQuery = {
  __typename?: 'Query';
  maintenanceMessages: Array<{
    __typename?: 'MaintenanceMessage';
    message: string;
    severity: MaintenanceMessageSeverity;
  }>;
};

export type GetMaintenanceMessagesMarblesQueryVariables = Exact<{ [key: string]: never }>;

export type GetMaintenanceMessagesMarblesQuery = {
  __typename?: 'Query';
  marblesMaintenanceMessages: Array<{
    __typename?: 'MaintenanceMessage';
    message: string;
    severity: MaintenanceMessageSeverity;
  }>;
};

export type GetProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetProfileQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'UserProfile';
    username: string;
    name: string;
    status: UserStatus;
    allowedUserActions: Array<UserAction>;
    enabledModules: Array<ApplicationModule>;
  };
};

export type GetProfileMarblesQueryVariables = Exact<{ [key: string]: never }>;

export type GetProfileMarblesQuery = {
  __typename?: 'Query';
  marblesMe: {
    __typename?: 'UserProfile';
    username: string;
    name: string;
    status: UserStatus;
    allowedUserActions: Array<UserAction>;
    enabledModules: Array<ApplicationModule>;
  };
};
